// Dashboard freight-handshake + Shopify-fulfillment-sync handlers, extracted
// from sections/rep-quote-dashboard.liquid to keep that file under Shopify's
// 256 KB section hard limit.
//
// All cross-file deps are passed through window.RPDash, set up by the
// dashboard's inline boot script:
//   window.RPDash = { allQuotes, API, buildDetailHtml, refreshProgressBar,
//                     vendorNamesMatch, esc }
//
// Exposed: window.DashboardHandshake.{ request, saveCost, editCost, reset,
//                                      shopifySync, getVendorFreightExtras }
(function () {

  /* CUSTOM_ABBYCATALOG_BY_CLAUDE (AIOPS suggestion 774bffc31d99, Ryan 2026-09-02) — the rep edited
     the deal ref out of the subject.

     ⛔ WARN, NEVER REFUSE, and it fires AFTER the send. Ryan settled the shape on 2026-08-30:
     "guarantee on server-generated subjects, warn on composer-typed ones, and nothing refuses to
     send." The suggestion asked for a refusal; this path carries real customer mail, and the only
     thing a runtime block achieves is an email that does not go out. The cost of the missing ref
     is real but small and recoverable — a reply will not file itself against the deal — so the rep
     is told once, plainly, and never stopped.

     ⛔ ONE HELPER, TWO SEND SITES. Both shipping paths (the notify pop-up and the composer
     override) post a `subject`, so both can drop the ref. Two copies of this is how one of them
     ends up silently not warning. */
  function warnIfSubjectDroppedRef(resp) {
    var w = resp && resp.success && resp.refWarning;
    if (!w || !w.message) return;
    alert('Sent, but ' + w.message
      + '\n\nIf they reply, file it on the deal by hand, or keep '
      + (w.ref || 'the deal reference') + ' in the subject next time.');
  }

  'use strict';

  function dash() { return window.RPDash || {}; }

  /* CUSTOM_SHIPFROM_BY_CLAUDE (AIOPS 89721f96ff00) — may this person send as ryan@?
     ⚠️ `session.admin`, never `session.role`: role reads "rep" for an admin. RPDash carries no
     admin flag, so the session is read directly, exactly as dashboard-email-modal.js does. */
  function _ncIsAdmin() {
    try {
      var s = (window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession()) || {};
      return s.admin === true;
    } catch (_) { return false; }
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — A customer-email field
     (wm.customer.email / shipEmail) may legitimately hold a comma/semicolon-
     joined list, e.g. "elewis@…, cadams@…" (RW-1177-B, City of Bakersfield —
     Eileen Lewis + Codi Adams). The shared composer treats prefillTo as ONE
     chip and never splits it (dashboard-email-modal.js: toChips = [prefillTo]),
     so a 2-address string would land as a single malformed To: recipient that
     bounces. Split it here at the call site: the FIRST address becomes To, every
     remaining address — plus any extraCc passed in (each itself possibly a list)
     — overflows into Cc, deduped, with the To address excluded. Behavior-
     preserving for the common single-address case. Mirrors the worker's
     firstEmail() (quote-pdf.js). Used by all three customer-email composers
     (Mark-as-Fulfilled / offline Notify Customer / sample shipment). */
  function splitRecipients(toStr, extraCc) {
    function expand(v) {
      return String(v == null ? '' : v).split(/[,;]/)
        .map(function (s) { return s.trim(); }).filter(Boolean);
    }
    var all = expand(toStr);
    (Array.isArray(extraCc) ? extraCc : []).forEach(function (e) { all = all.concat(expand(e)); });
    var to = all[0] || '';
    var seen = {};
    if (to) seen[to.toLowerCase()] = 1;
    var cc = [];
    all.slice(1).forEach(function (a) {
      var k = a.toLowerCase();
      if (!seen[k]) { seen[k] = 1; cc.push(a); }
    });
    return { to: to, cc: cc };
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Shared detail-panel re-render helper.
     Every callsite that wipes detailEl.innerHTML to rebuild from q needs:
       1. blur the active element BEFORE wipe (otherwise the next
          focusable element gets focus → scroll-snaps up on tall pages)
       2. snapshot scrollY so the user's position survives the rebuild
       3. write innerHTML
       4. re-attach collapse handlers via applyCollapseState (innerHTML
          replacement strips the --collapsible classes it injects)
       5. restore scrollY
     Without this sequence, cards lock open after save / fulfillment and
     the page jumps up. Factored out so all four handshake call sites
     stay in lockstep — adding a new mutation handler now is one line. */
  function rerenderDetail(detailEl, q) {
    if (!detailEl || !q) return;
    var d = dash();
    var _scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
    detailEl.innerHTML = d.buildDetailHtml ? d.buildDetailHtml(q) : '';
    if (d.applyCollapseState) d.applyCollapseState(detailEl, q);
    window.scrollTo(0, _scrollY);
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* FREIGHT-INPUTS-TWIN:BEGIN
     ─────────────────────────────────────────────────────────────────────────────
     CUSTOM_FREIGHTTWIN_BY_CLAUDE (AIOPS suggestion 6743fdf255d8, Ryan 2026-09-03)

     ⛔ THE OTHER HALF OF THE FREIGHT COMPOSER, AND THE HALF THAT IS EASY TO FORGET. The
     FREIGHT-COMPOSE-TWIN span in dashboard-freight-modal.js renders the email; THIS decides what
     goes in it — which line items are this supplier's, how the qty column reads, where the goods
     are going, whether the address is a residence, and which bucket's SKUs an ask covers. A
     rendering that matches perfectly over the wrong item list is still the wrong email.

     Its twin is `src/lib/freight-request-inputs.js` in the rfq-worker, and
     `tests/freight-compose-parity.test.mjs` asserts the two agree for every fixture.

     ⚠️ TWO GLOBALS ARE READ IN HERE AND THE EXTRACTOR SUPPLIES BOTH, deliberately rather than by
     copying their bodies in:
       · `dash().vendorNamesMatch` — the DD's own rule, marked FREIGHT-VENDORMATCH-TWIN in
         dashboard-main.js. ⛔ It is NARROWER than the worker's `lib/vendor-canonical.js`
         `vendorMatches`, which also resolves brand rollups (Normatec → Hyperice). Using the wider
         one server-side would put line items in an agent's email that the button leaves out, so
         the worker port deliberately does NOT reuse `vendorMatches` here. That is the single
         easiest way this whole build could have quietly produced a different email.
       · `window.RepPortal.destinationTypeFromOrg` — marked FREIGHT-DESTTYPE-TWIN in
         custom-rep-portal.js, already shared with the Quote Workstation.
     Nothing else impure may enter this span; `freightLineItemsFor` was moved out below for
     exactly that reason.
     ───────────────────────────────────────────────────────────────────────────── */
  function vendorNamesMatch(a, b) {
    var fn = dash().vendorNamesMatch;
    if (typeof fn === 'function') return fn(a, b);
    var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var A = norm(a), B = norm(b);
    return !!A && !!B && (A === B || A.startsWith(B) || B.startsWith(A));
  }

  // ── Vendor freight quirks ───────────────────────────────────────────
  function classifyShippingMethodForEcore(method) {
    /* CUSTOM_CARRIERNAMES_BY_CLAUDE (ONYX 609f1d1514ca) - a FREIGHT service named Priority (GoRocket's FedEx Freight Priority, FXFE)
       is not a FedEx Priority Overnight ship-via; only a parcel Priority method asks ECORE for overnight. */
    var _m = String(method || '');
    return (/priority/i.test(_m) && !/freight|ltl|truck|pallet/i.test(_m)) ? 'priority' : 'standard';
  }
  function buildEcoreShipViaValue(methods) {
    if (!methods || methods.length === 0) return null;
    var classes = methods.map(classifyShippingMethodForEcore);
    var hasPriority = classes.indexOf('priority') !== -1;
    var hasStandard = classes.indexOf('standard') !== -1;
    if (hasPriority && hasStandard) {
      return 'Mixed shipping — some items via FedEx Ground, others via FedEx Priority. Please confirm which apply to your items below.';
    }
    if (hasPriority) return 'FedEx Priority';
    return 'FedEx Ground';
  }
  /* CUSTOM_ECOREWEST_BY_CLAUDE (AIOPS 98072644dbca, 2026-09-08) — ECORE West's own ask. Richard
     Moronta (ECORE West) on SHOP-2032's rate thread: when a shipment is West-bound, say "if
     possible, please source from Corona, CA" so they quote from the Corona plant and the rate is
     lower. Mountain + Pacific states; the line rides only on a RATE ask (freight / both), never on
     a dims ask, and only when the ship-to state is known — a blank state is not "East". */
  /* CUSTOM_PRODUCTRULES_BY_CLAUDE (Session 7, Ryan 2026-10-10) - the list is a stored setting now, edited on Product Rules
     and read from GET /rule-settings (setEcoreWestStates). This is its default, used until that answers; a test holds it
     equal to the worker's DEFAULT_ECORE_WEST_STATES (lib/rule-settings.js). */
  var ECORE_WEST_STATES = ['AK', 'AZ', 'CA', 'CO', 'HI', 'ID', 'MT', 'NV', 'NM', 'OR', 'UT', 'WA', 'WY'];
  function setEcoreWestStates(list) {
    if (!Array.isArray(list)) return;
    ECORE_WEST_STATES = list.map(function (x) { return String(x || '').trim().toUpperCase(); }).filter(function (x) { return /^[A-Z]{2}$/.test(x); });
  }
  /* CUSTOM_ASKCLAUSE_BY_CLAUDE (AIOPS `317cf637f554`, Ryan 2026-09-11) — ⚠️ THIS IS A CLAUSE,
     NOT A PARAGRAPH. It used to render as its own line ABOVE the greeting, which is how SHOP-2050
     went out instructing ECORE before saying hello. `weaveAskClauses` (dashboard-freight-modal.js)
     now folds it into the ask sentence — lowercased, full stop removed — so it reads "… for the
     items listed below, and if possible, please source from Corona, CA." Keep any line added here
     readable BOTH ways: as a clause after "and", and as a standalone sentence, which is the
     fallback when a vendor's own Guide body has no ask sentence to join. */
  var ECORE_WEST_SOURCE_LINE = 'If possible, please source from Corona, CA.';
  function shipToStateOf(q) {
    var s = (q && q.shipTo) || {};
    return String(s.state || (q && q.state) || '').trim().toUpperCase();
  }
  function isEcoreWestBound(q, states) {
    return (Array.isArray(states) ? states : ECORE_WEST_STATES).indexOf(shipToStateOf(q)) !== -1;
  }

  /* CUSTOM_PARCELBAND_BY_CLAUDE (AIOPS 55ef1f974a9f, Ryan 2026-09-21 - SHOP-2083) — the twin of the
     worker's rule (lib/freight-request-inputs.js, same tag): a bucket the board already judged
     under the parcel band (`rateAsk.downgrade`) asks, in Ryan's own sentence, for FedEx Ground
     parcel rates rather than LTL, with the weight. The parity test proves the two copies agree. */
  /* CUSTOM_PARCELASK_BY_CLAUDE (ONYX d4ef3836f115, Ryan 2026-10-16 - RW-1507-A) — the twin of the worker's
     parcelBandFromVerdict: a deal with NO buckets (offline) is under the parcel band when the worker's own
     verdict (opts.parcelBand, served on /vendor-freight-email) says so. Every supplier now, and the ask
     sentence itself is reworded in the composer (weaveParcelAsk) instead of a clause being woven in. */
  function parcelBandFromVerdict(q, verdict) {
    var list = Array.isArray(q && q.shippingBuckets) ? q.shippingBuckets.filter(Boolean) : [];
    if (list.length) return null;
    if (!verdict || verdict.downgrade !== true || !(Number(verdict.lb) > 0)) return null;
    return { id: null, lb: Number(verdict.lb) };
  }
  function parcelBandBucket(q, bucketId) {
    var list = Array.isArray(q && q.shippingBuckets) ? q.shippingBuckets.filter(Boolean) : [];
    var id = String(bucketId == null ? '' : bucketId).trim();
    var cands = id ? list.filter(function (b) { return b.id === id; }) : (list.length === 1 ? list : []);
    if (cands.length !== 1) return null;
    var b = cands[0];
    var ra = b.rateAsk;
    if (!ra || ra.downgrade !== true || !(Number(ra.lb) > 0)) return null;
    if (String(b.requestKind || 'freight') !== 'freight') return null;
    return { id: b.id, lb: Number(ra.lb) };
  }

  var VENDOR_FREIGHT_QUIRKS = {
    'ECORE': function (q, emailType, bucketId, opts) {
      var v = buildEcoreShipViaValue(q.onlineShippingMethods || []);
      var out = v ? { shipVia: v } : {};
      var asksRate = emailType === 'freight' || emailType === 'both';
      if (asksRate) {
        var lines = [];
        if (isEcoreWestBound(q, opts && opts.westStates)) lines.push(ECORE_WEST_SOURCE_LINE);
        if (lines.length) out.bodyLines = lines;
      }
      return out;
    },
  };
  /* `emailType` (freight | dims | both) is optional; a caller that does not say is asking for no
     rate-only lines — the ship-via value never depended on it and still does not. `bucketId`
     names the shipping bucket the ask is for (CUSTOM_PARCELBAND_BY_CLAUDE). */
  function getVendorFreightExtras(vendor, q, emailType, bucketId, opts) {
    var extras = { bodyLines: [], shipVia: null, parcel: null };
    if (emailType === 'freight' || emailType === 'both') {   // CUSTOM_PARCELASK_BY_CLAUDE — any supplier
      var band = parcelBandBucket(q, bucketId) || parcelBandFromVerdict(q, opts && opts.parcelBand);
      if (band) extras.parcel = { lb: band.lb };
    }
    Object.keys(VENDOR_FREIGHT_QUIRKS).forEach(function (key) {
      if (vendorNamesMatch(vendor, key)) {
        var result = VENDOR_FREIGHT_QUIRKS[key](q, emailType, bucketId, opts) || {};
        if (Array.isArray(result.bodyLines)) extras.bodyLines = extras.bodyLines.concat(result.bodyLines.filter(Boolean));
        if (result.shipVia) extras.shipVia = result.shipVia;
      }
    });
    return extras;
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Selling-unit suffix for the freight/dims
     email qty column, mirroring the PO PDF's UOM rule. The PO derives its
     unit from the rep's quote sub-text, but online orders carry no sub-text,
     so here we key off the product's `unit:{x}` tag (catalog convention:
     unit:sqft / unit:tile / unit:paver / unit:plank). Display: 'sqft' stays
     as-is; piece units pluralize for readability ("tile" -> "tiles") with a
     generic +s fallback so any future unit:X tag works without code change. */
  function freightUnitNoun(tags) {
    if (!Array.isArray(tags)) return '';
    var raw = '';
    for (var i = 0; i < tags.length; i++) {
      var m = /^unit:(.+)$/i.exec(String(tags[i] || '').trim());
      if (m) { raw = m[1].trim().toLowerCase(); break; }
    }
    if (!raw) return '';
    if (/^(sqft|sf|sq\.?\s*ft|square\s*f(?:ee)?t)$/.test(raw)) return 'sqft';
    return /s$/.test(raw) ? raw : raw + 's';
  }
  /* CUSTOM_ASKUNITS_BY_CLAUDE (ONYX 8737a938898f, Ryan 2026-10-14) - the qty cell reads the way the PO
     prints it: "464 sq ft", "75 tiles", and "(2x)" for an each-item. `poUnit` is the unit the PO builder
     reads off the rep's quote sub-text (shipped on each offline line by /quote-details); it wins over the
     product's unit:{x} tag. 'sqft' prints "sq ft" exactly as the PO PDF does. */
  function freightQtyStr(qty, unit) {
    var u = String(unit || '').trim();
    if (!u) return '(' + qty + 'x)';
    return qty + ' ' + (u.toLowerCase() === 'sqft' ? 'sq ft' : u);
  }
  /* CUSTOM_FREIGHTTWIN_BY_CLAUDE (Ryan 2026-09-03) — takes the RESOLVED line array, not `q`.
     The caller decides where the lines came from (a live read, the board copy, the offline
     cache); that choice is client-side state with no server analogue, and keeping it out is what
     lets this function be shared with the worker.

     ⚠️ The rule it used to own — a fresh live read WINS over the cached board copy, because the
     bake trails a Shopify order edit by ~20s (CUSTOM_FREIGHTITEMS_BY_CLAUDE, Ryan 2026-08-29) —
     moved to the call site with the resolution, unchanged. Passed in rather than written onto
     `q.onlineLineItems`: that array feeds Order Contents and carries far more per-line state
     (line totals, unit costs, weights, roll layouts, per-line flags) than a freight ask needs,
     so overwriting it with a thin projection would quietly strip the card. */
  /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09) - `overrides` is the deal's `lineVendorOverrides`: a line moved
     to an alternate source on an OFFLINE deal still carries the brand's name, so the override names the
     supplier it now goes to. No overrides = the old filter, unchanged. */
  function buildFreightItemsForVendor(lineItems, vendor, overrides) {
    var ov = (overrides && typeof overrides === 'object') ? overrides : null;
    var lineVendor = function (li) {
      var o = ov && li && li.lineItemId ? ov[li.lineItemId] : null;
      return (o && o.vendor) ? o.vendor : ((li && li.vendor) || '');
    };
    return (Array.isArray(lineItems) ? lineItems : [])
      .filter(function (li) { return vendorNamesMatch(lineVendor(li), vendor); })
      .map(function (li) {
        // Offline items carry `qty`; online carry `quantity`. (Ryan 2026-08-26)
        var qty = li.quantity || li.qty || 1;
        var unitNoun = li.poUnit || freightUnitNoun(li.productTags || []); // poUnit: CUSTOM_ASKUNITS_BY_CLAUDE
        return {
          // CUSTOM_RFQPORTAL_BY_CLAUDE — lineItemId surfaced so the
          // bucket-aware item filter in openFreightModal can match each
          // item against the bucket's lineItemIds whitelist. Without
          // this the filter strips everything and the email's Items
          // block ends up empty.
          lineItemId: li.lineItemId,
          // Qty reads "464 sq ft" / "75 tiles" when the line has a unit (the PO's,
          // else the tag's), else "(2x)".
          qtyStr: freightQtyStr(qty, unitNoun),
          title: li.title || '',
          sku: li.sku || '',
          subLines: [],
        };
      });
  }
  // Prefer the Ship To address when present — that's where the goods
  // physically go, and freight quotes hinge on it. Top-level q.city/state/
  // zip come from Sold To (billing for online orders, often a corporate
  // billing office in a different state). Fixes SHOP-1669 freight email
  // sending billing city/zip to the supplier.
  //
  // Per-field fallback (not all-or-nothing): a partially-populated shipTo
  // (e.g. only zip set) shouldn't blank out the city + state. Each field
  // independently prefers shipTo when populated, falls through to the
  // top-level Sold To when shipTo's value for THAT field is empty.
  // CUSTOM_RFQPORTAL_BY_CLAUDE — structured ship-to parts so the freight email can
  // render the address in a neat table (mirrors the items table) instead of a flat
  // text line. buildFreightShipToForOrder keeps returning the legacy flat string.
  function buildFreightShipToParts(q) {
    var s = q.shipTo || {};
    var city = (s.city || q.city || '').trim();
    var st = (s.state || q.state || '').trim();
    var zip = (s.zip || q.zip || '').trim();
    var loc = '';
    if (city && st) loc = city + ', ' + st + ' ' + zip;
    else if (city) loc = city + ' ' + zip;
    else loc = zip;
    loc = loc.trim();
    /* CUSTOM_SHIPTOTYPE_BY_CLAUDE (ONYX 33b3cb16fbc5, Ryan 2026-10-11, SHOP-2161 TEST 150) - a Ship To that names a
       place decides the type by ITS OWN company. Borrowing the Sold To company ("Cool Company", the billing name) told
       ECORE "Non-residence" for an apartment. Only a deal with no Ship To at all falls back to the Sold To company. */
    var shipHasPlace = !!(s.street || s.city || s.zip);
    var rawCompany = shipHasPlace ? s.company : (s.company || q.customerCompany);
    /* CUSTOM_FREIGHTTYPE_BY_CLAUDE (Ryan 2026-08-27) — was an inline exact-match against
       ['', 'na', 'none', 'residence', 'residential', 'home'] AFTER stripping punctuation, so the
       rep's "N/a - Residence" fused into `naresidence`, matched nothing, and told the supplier
       Type: Non-residence for a house. Shared rule now — the Quote Workstation prints this same
       field and had its own copy. Reasoning lives on destinationTypeFromOrg.

       ⚠️ Falls back to 'Residence', not 'Non-residence'. This should be unreachable (the shared
       asset loads first on this page), but if it ever is not, the cheap error is quoting a
       residential surcharge we did not need — the other way round we find out via a re-bill after
       the customer has already been quoted. */
    var type = (window.RepPortal && window.RepPortal.destinationTypeFromOrg)
      ? window.RepPortal.destinationTypeFromOrg(rawCompany)
      : 'Residence';
    return { location: loc, type: type };
    /* END CUSTOM_FREIGHTTYPE_BY_CLAUDE */
  }
  function buildFreightShipToForOrder(q) {
    var p = buildFreightShipToParts(q);
    return p.location + (p.location ? ' - ' : '') + p.type;
  }
  function freightShipZipForOrder(q) {
    var s = q.shipTo || {};
    return ((s.zip || q.zip) || '').toString().trim();
  }

  /* CUSTOM_FREIGHTTWIN_BY_CLAUDE (Ryan 2026-09-03) — lifted out of openFreightModal so the worker
     can run it. Behaviour and comments are unchanged; only the inputs are now arguments instead of
     closure variables. */
  function filterItemsToBucket(items, bucket, shippingBuckets) {
    // Bucket-scoped item list. Use the bucket's lineItemIds (when bucket
    // is set) to filter the vendor's items to ONLY this shipping flow's
    // line items, so the email shows the supplier exactly the SKUs we
    // need this particular ask to cover.
    items = Array.isArray(items) ? items : [];
    if (!bucket || !Array.isArray(shippingBuckets)) return items;
    var bucketRec = shippingBuckets.find(function (b) { return b && b.id === bucket; });
    var allowedIds = bucketRec && Array.isArray(bucketRec.lineItemIds) ? bucketRec.lineItemIds : null;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket filter restored. Earlier in
       this iteration cycle the filter was bypassed for substituting
       parents because bucket.lineItemIds referenced the parent's
       original Shopify GIDs while q.onlineLineItems had been swapped
       to child draft GIDs (no overlap → blank items). The worker now
       re-derives shipping buckets after the substitution swap so
       bucket.lineItemIds are keyed by the child's draft GIDs, matching
       q.onlineLineItems. The filter once again correctly scopes each
       supplier email to its bucket's items. */
    if (!allowedIds || allowedIds.length === 0) return items;
    /* CUSTOM_FREIGHTITEMS_BY_CLAUDE (Ryan 2026-08-29) — ⛔ THE WHITELIST IS STALE FOR EXACTLY
       THE SAME REASON THE ITEM LIST WAS, and fixing only the list would have changed nothing.

       `allowedIds` comes from `q.shippingBuckets[].lineItemIds`, i.e. the same ~20s-behind bake
       as `q.onlineLineItems`. On SHOP-1997 both held ONE id, so they agreed with each other and
       the composer showed one item with total confidence. Reading the lines live and then
       filtering them against a whitelist minted before they existed would have thrown the two
       new ones straight back out.

       So the whitelist is authoritative about lines it KNOWS, and silent about lines it has
       never seen: keep a line if THIS bucket claims it, or if NO bucket does.

       ⚠️ That leans on an invariant this codebase already states and guarantees — a vendor's
       lines are all-broker or all-parcel, never split, because `_isFreightQuoted` ORs a line's
       own state with `_fqVendors`. `items` is already scoped to one vendor, so a line the bake
       has not placed yet belongs to whichever bucket that vendor's other lines are in — this
       one. ⛔ A line the bake DID place in the other bucket is still excluded, which is the
       part a blanket "skip the filter" would have got wrong. */
    var _placed = {};
    shippingBuckets.forEach(function (b) {
      (b && Array.isArray(b.lineItemIds) ? b.lineItemIds : []).forEach(function (id) { _placed[id] = 1; });
    });
    return items.filter(function (it) {
      return allowedIds.indexOf(it.lineItemId) !== -1 || !_placed[it.lineItemId];
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
  }

  /* CUSTOM_PRIORDIMS_BY_CLAUDE (AIOPS 72635be15403, Ryan 2026-09-28) — a freight ask to a supplier
     who already sent weight & dims says so: 'compare' (dims answered AND a GoRocket / broker rate
     on the deal), 'thanks' (dims answered, no carrier rate), null otherwise and for every dims /
     both ask. ⛔ TWIN of src/lib/freight-request-inputs.js — edit both or the parity test goes red. */
  function isGoRocketLike(name) {
    return String(name || '').toLowerCase().replace(/[^a-z]/g, '').indexOf('gorocket') === 0;
  }
  function positiveNum(v) { var n = Number(v); return isFinite(n) && n > 0; }
  function carrierRateOnDeal(q) {
    q = q || {};
    if (q.brokerQuoted === true) return true;
    var buckets = Array.isArray(q.shippingBuckets) ? q.shippingBuckets : [];
    for (var i = 0; i < buckets.length; i++) {
      var b = buckets[i];
      if (b && positiveNum(b.freightCost) && (b.type === 'broker' || isGoRocketLike(b.carrier))) return true;
    }
    var fq = (q.freightQuotes && typeof q.freightQuotes === 'object') ? q.freightQuotes : {};
    var keys = Object.keys(fq);
    for (var j = 0; j < keys.length; j++) {
      if (isGoRocketLike(keys[j]) && fq[keys[j]] && positiveNum(fq[keys[j]].cost)) return true;
    }
    var ws = (q.wsFreight && Array.isArray(q.wsFreight.vendors)) ? q.wsFreight.vendors : [];
    for (var k = 0; k < ws.length; k++) {
      var r = ws[k];
      if (r && positiveNum(r.cost) && (isGoRocketLike(r.name) || isGoRocketLike(r.carrier))) return true;
    }
    return false;
  }
  function priorDimsFor(vendor, q, emailType) {
    if (emailType !== 'freight') return null;
    q = q || {};
    var answered = false;
    var fq = (q.freightQuotes && typeof q.freightQuotes === 'object') ? q.freightQuotes : {};
    Object.keys(fq).forEach(function (key) {
      var e = fq[key];
      if (!e || !e.answeredAt || !vendorNamesMatch(key, vendor)) return;
      if (String(e.kind || '').toLowerCase() === 'dims' || e.dimsRequestedAt) answered = true;
    });
    (Array.isArray(q.shippingBuckets) ? q.shippingBuckets : []).forEach(function (b) {
      var req = b && b.request;
      if (!req || !req.answeredAt) return;
      if (String(req.kind || b.requestKind || '').toLowerCase() !== 'dims') return;
      var owner = b.vendor || b.vendorName || req.vendor || '';
      if (owner && !vendorNamesMatch(owner, vendor)) return;
      answered = true;
    });
    if (!answered) return null;
    return carrierRateOnDeal(q) ? 'compare' : 'thanks';
  }
  /* END CUSTOM_PRIORDIMS_BY_CLAUDE */

  /* What the parity test pulls out of this block — see the BEGIN marker. */
  var FreightInputsTwin = {
    vendorNamesMatch: vendorNamesMatch,
    classifyShippingMethodForEcore: classifyShippingMethodForEcore,
    buildEcoreShipViaValue: buildEcoreShipViaValue,
    getVendorFreightExtras: getVendorFreightExtras,
    parcelBandBucket: parcelBandBucket,     /* CUSTOM_PARCELBAND_BY_CLAUDE — compared by the parity test */
    parcelBandFromVerdict: parcelBandFromVerdict,   /* CUSTOM_PARCELASK_BY_CLAUDE */
    freightUnitNoun: freightUnitNoun,
    freightQtyStr: freightQtyStr,           /* CUSTOM_ASKUNITS_BY_CLAUDE */
    buildFreightItemsForVendor: buildFreightItemsForVendor,
    buildFreightShipToParts: buildFreightShipToParts,
    buildFreightShipToForOrder: buildFreightShipToForOrder,
    freightShipZipForOrder: freightShipZipForOrder,
    filterItemsToBucket: filterItemsToBucket,
    carrierRateOnDeal: carrierRateOnDeal,   // CUSTOM_PRIORDIMS_BY_CLAUDE
    priorDimsFor: priorDimsFor,
  };
  /* FREIGHT-INPUTS-TWIN:END */

  /* CUSTOM_FREIGHTTWIN_BY_CLAUDE (Ryan 2026-09-03) — moved out of the FREIGHT-INPUTS-TWIN
     span: it reads `window.__orderContentsCache`, which the parity test cannot evaluate and
     the worker has no equivalent of. Verbatim otherwise. */
  /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — where this deal's line items live.
     Online orders carry them inline on the row; OFFLINE deals do not — theirs are lazy-loaded via
     /quote-details on first expand of the detail panel and cached module-side so they survive the
     2-minute auto-refresh. Same resolution order dashboard-main.js:3752 uses. */
  function freightLineItemsFor(q) {
    if (!q) return [];
    if (Array.isArray(q.onlineLineItems) && q.onlineLineItems.length) return q.onlineLineItems;
    if (Array.isArray(q.offlineLineItems) && q.offlineLineItems.length) return q.offlineLineItems;
    var cache = window.__orderContentsCache;
    var hit = cache && q.reference ? cache[q.reference] : null;
    return Array.isArray(hit) ? hit : [];
  }
  /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */

  // ── Freight quote handshake handlers ────────────────────────────────
  // openFreightModal handles both Flow B's full freight quote ask and Flow
  // A's weight/dims-only ask — they share the supplier email modal but
  // pre-fill different subjects/body intros based on `type`. Type also
  // flows through to the worker so `freightQuotes[v].kind` records which
  // ask was made.
  //
  // CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket-aware path:
  // Mixed-cart orders need per-bucket request state on the same vendor
  // (e.g. SHOP-1681 needs a broker dims request AND a parcel quote
  // request for ECORE, independently). When a bucket key is supplied,
  // (a) only the items in that bucket are listed in the email body —
  // supplier sees exactly what we're asking them to quote, and
  // (b) the worker stores the request state on
  // workstation_meta.shippingBuckets[bucket].request instead of
  // lc.freightQuotes[vendor], so both buckets can hold independent
  // requested-at timestamps for the same vendor.
  async function openFreightModal(ref, vendor, type, bucket) {
    var d = dash();
    if (!ref || !vendor) return;
    var q = (d.allQuotes || []).find(function (x) { return x.reference === ref; });
    if (!q) return;
    if (!window.DashboardFreightModal) {
      alert('Freight modal not loaded yet — refresh the page.');
      return;
    }
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — an OFFLINE deal's line items are lazy,
       and this email is the one place their absence is invisible: the modal opens, the ITEMS block
       is simply empty, and the supplier gets a freight request for nothing. Fetch them before
       opening rather than after. Normally a no-op — the Purchasing card only renders inside an
       expanded panel, which has already loaded them — so this covers the cold-cache races (a
       refresh landing mid-expand, a panel restored from a deep link). Non-fatal: if the fetch
       fails the modal still opens and the rep can see for themselves that the items are missing,
       which beats a silent dead end. */
    /* CUSTOM_FREIGHTITEMS_BY_CLAUDE (Ryan 2026-08-29) — ⛔ AN ONLINE ORDER'S LINES ARE READ LIVE,
       EVERY TIME THIS OPENS.

       Ryan on SHOP-1997, seconds after adding two items through Adjust Order: *"I clicked the
       Email ECORE button to request weight/dims -- and it only showed me the 1 original item ...
       I then waited 20 seconds and clicked it again, and then the other 2 items populated."*

       `q.onlineLineItems` is the baked dd-summary, which trails a Shopify order edit by ~20s. The
       guard below covers only an EMPTY list, so a stale-but-populated one walked through it — and
       the composer SENDS THE HTML IT RENDERED, so the supplier would have quoted a shipment
       missing two items with nothing anywhere to catch it.

       ⚠️ Not gated on "did anything change", because the client cannot know that — the whole
       problem is that its copy is the thing that is behind. One cheap Shopify read per composer
       open is the price of never asking a vendor to quote the wrong shipment.
       ⚠️ Non-fatal: a failed read falls back to the cached list, which is exactly today's
       behaviour rather than a dead end. */
    var _freshLines = null;
    if (q.source === 'online') {
      try {
        var _ol = await d.API.get('/online-order-lines?ref=' + encodeURIComponent(ref));
        if (_ol && _ol.found && Array.isArray(_ol.lineItems) && _ol.lineItems.length) _freshLines = _ol.lineItems;
      } catch (e) { /* non-fatal — see above */ }
    }
    if (!freightLineItemsFor(q).length && q.source !== 'online') {
      try {
        var _qd = await d.API.get('/quote-details?ref=' + encodeURIComponent(ref));
        /* The items hang off res.quote.lineItems, NOT res.lineItems — same shape the Order
           Contents lazy-load reads (dashboard-main.js:11167). Spacers are layout rows on the
           quote and have no place on a freight request. Only the fields this email needs are
           kept; the Order Contents transform builds a much richer row for a different purpose. */
        var _raw = (_qd && _qd.quote && Array.isArray(_qd.quote.lineItems)) ? _qd.quote.lineItems : [];
        var _items = _raw.filter(function (li) { return li && !li.isSpacer; }).map(function (li) {
          return {
            lineItemId: li.lineItemId || '',
            vendor: li.vendor || '',
            title: li.title || '',
            sku: li.sku || '',
            quantity: parseInt(li.quantity, 10) || 0,
            poUnit: li.poUnit || '', // CUSTOM_ASKUNITS_BY_CLAUDE - the PO's unit for this line
          };
        });
        if (_items.length) {
          q.offlineLineItems = _items;
          if (typeof window.__orderContentsCache !== 'object' || window.__orderContentsCache === null) {
            window.__orderContentsCache = {};
          }
          window.__orderContentsCache[ref] = _items;
        }
      } catch (e) { /* non-fatal — see above */ }
    }
    /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
    var rec = {};
    try {
      var data = await d.API.get('/vendor-contacts');
      var contacts = (data && data.contacts) || {};
      rec = contacts[vendor] || {};
    } catch (e) { /* non-fatal */ }
    // CUSTOM_RFQPORTAL_BY_CLAUDE — per-vendor freight-request verbiage (Edit Vendor
    // → PO Profile). Non-fatal: the modal falls back to its built-in default copy
    // when this is empty or the fetch fails.
    var vendorFreight = {};
    try {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — pass the deal ref so a white-label row
         resolves to the supplier THIS deal was pointed at. Without it a quote name claimed by two
         suppliers resolves to nobody and the modal falls back to empty recipients. */
      var fv = await d.API.get('/vendor-freight-email?vendor=' + encodeURIComponent(vendor) + '&ref=' + encodeURIComponent(ref));
      /* CUSTOM_ONEFREIGHTCOMPOSER_BY_CLAUDE (Ryan 2026-08-28) — the per-type To/CC/BCC merge that
         used to live here moved INTO the composer (mergeVendorRecipients in
         dashboard-freight-modal.js). It was a rule about how a vendor's profile beats a
         remembered contact, sitting in one of the two callers — so the Quote Workstation, now
         opening the same composer, would have had no version of it. The composer receives
         `vendorFreight` and `vendorRecipients` and resolves them itself. */
      if (fv) vendorFreight = fv;
    } catch (e) { /* non-fatal */ }
    var quirkExtras = getVendorFreightExtras(vendor, q, type || 'freight', bucket, { parcelBand: (vendorFreight && vendorFreight.parcelBand) || null }); // bucket: CUSTOM_PARCELBAND_BY_CLAUDE; parcelBand: CUSTOM_PARCELASK_BY_CLAUDE (an offline deal's verdict, off /vendor-freight-email)
    // Bucket-scoped item list. Use the bucket's lineItemIds (when bucket
    // is set) to filter the vendor's items to ONLY this shipping flow's
    // line items, so the email shows the supplier exactly the SKUs we
    // need this particular ask to cover.
    /* CUSTOM_FREIGHTTWIN_BY_CLAUDE (Ryan 2026-09-03) — the line resolution and the bucket filter
       moved into the FREIGHT-INPUTS-TWIN span above so the worker runs the same two steps. What
       stays here is the impure half: which cache the lines came from, and finding the bucket
       record. See the twin header for why. */
    var items = filterItemsToBucket(
      buildFreightItemsForVendor(
        (Array.isArray(_freshLines) && _freshLines.length) ? _freshLines : freightLineItemsFor(q),
        vendor,
        q.lineVendorOverrides, // CUSTOM_ALTSHIP_BY_CLAUDE
      ),
      bucket,
      q.shippingBuckets,
    );
    window.DashboardFreightModal.open({
      quoteRef: ref,
      zip: freightShipZipForOrder(q),
      vendorName: vendor,
      type: type || 'freight',
      bucket: bucket || null,
      items: items,
      shipTo: buildFreightShipToForOrder(q),
      shipToParts: buildFreightShipToParts(q), // CUSTOM_RFQPORTAL_BY_CLAUDE — neat-table address
      shipVia: quirkExtras.shipVia,
      vendorRecipients: rec,
      vendorFreight: vendorFreight, // CUSTOM_RFQPORTAL_BY_CLAUDE — per-vendor freight verbiage
      extraBodyLines: quirkExtras.bodyLines,
      parcel: quirkExtras.parcel,   // CUSTOM_PARCELASK_BY_CLAUDE — the ask asks for a parcel shipment quote
      priorDims: priorDimsFor(vendor, q, type || 'freight'),   // CUSTOM_PRIORDIMS_BY_CLAUDE (AIOPS 72635be15403)
      onSent: function (info) {
        /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09) - an ask to an alternate source in a shared bucket is that
           supplier's own: the worker stamps lifecycle.freightQuotes[name], never the bucket's request, so the
           optimistic stamp goes on its shipment entry and its per-supplier record. */
        var _spBucket = (bucket && Array.isArray(q.shippingBuckets)) ? q.shippingBuckets.find(function (b) { return b && b.id === bucket; }) : null;
        var _spEntry = (_spBucket && Array.isArray(_spBucket.suppliers))
          ? _spBucket.suppliers.find(function (e) { return e && !e.isBrand && e.vendor === vendor; }) : null;
        if (_spEntry) {
          _spEntry.requestedAt = info.requestedAt;
          _spEntry.scheduledFor = info.scheduledFor || null;
          if (!q.freightQuotes) q.freightQuotes = {};
          if (!q.freightQuotes[vendor]) q.freightQuotes[vendor] = {};
          q.freightQuotes[vendor].requestedAt = info.requestedAt;
          q.freightQuotes[vendor].scheduledFor = info.scheduledFor || null;
          q.freightQuotes[vendor].kind = (type === 'dims') ? 'dims' : 'freight';
        } else if (bucket && Array.isArray(q.shippingBuckets)) {
          // Optimistic in-memory update on the bucket so the panel
          // flips to "Requested ✓" immediately; the next fetchQuotes()
          // round will refresh from KV.
          var bRec = q.shippingBuckets.find(function (b) { return b.id === bucket; });
          if (bRec) {
            bRec.requestedAt = info.requestedAt;
            bRec.requestKind = type;
            // CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-28) — null on an immediate send, which is
            // what CLEARS a prior hold when a held request is re-sent inside the window.
            bRec.scheduledFor = info.scheduledFor || null;
          }
        } else {
          if (!q.freightQuotes) q.freightQuotes = {};
          if (!q.freightQuotes[vendor]) q.freightQuotes[vendor] = {};
          q.freightQuotes[vendor].requestedAt = info.requestedAt;
          q.freightQuotes[vendor].scheduledFor = info.scheduledFor || null;
          if (type === 'dims') q.freightQuotes[vendor].kind = 'dims';
          /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) - the dims half of a 'both' ask
             gets its OWN stamp rather than a third `kind` value. requestedAt is one timestamp,
             so a single enum could name freight-Monday or dims-Wednesday but never both - and
             the Options row now has to display exactly that. Optimistic mirror of what
             /freight-email writes. */
          if (type === 'both') q.freightQuotes[vendor].dimsRequestedAt = info.requestedAt;
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        rerenderDetail(detailEl, q);
        if (d.refreshProgressBar) d.refreshProgressBar(ref);
      },
    });
  }
  function request(ref, vendor, bucket) { return openFreightModal(ref, vendor, 'freight', bucket); }
  function requestDims(ref, vendor, bucket) { return openFreightModal(ref, vendor, 'dims', bucket); }
  /* One email carrying both asks. See the payload note in dashboard-freight-modal.js for why
     this is a composition rather than a third request kind. */
  function requestBoth(ref, vendor, bucket) { return openFreightModal(ref, vendor, 'both', bucket); }

  /* CUSTOM_OPTIMISTIC_BY_CLAUDE (Ryan 2026-08-27) — one copy of "a saved freight cost lands on the
     row", called by the immediate repaint AND by the pending-patch replay. Two copies of this
     arithmetic would let the instant view and the post-refetch view disagree about GP, which is a
     nastier version of the bug being fixed here.

     (Ryan 2026-08-26) Offline deals recompute too: the worker folds a saved supplier cost into
     wm.financials.freightCost for them as well, so without this the rep saves a number, watches the
     freight row flip, and sees the margin beside it keep the old figure — it reads as a half-save. */
  function applyFreightCost(q, vendor, entry) {
    if (!q) return;
    q.freightQuotes = q.freightQuotes || {};
    q.freightQuotes[vendor] = entry;
    if (!q.financials) return;
    var summed = 0;
    Object.keys(q.freightQuotes).forEach(function (v) {
      var c = parseFloat((q.freightQuotes[v] || {}).cost);
      if (!isNaN(c)) summed += c;
    });
    q.financials.freightCost = Math.round(summed * 100) / 100;
    var direct = parseFloat(q.financials.directTotal) || 0;
    var cogs = parseFloat(q.financials.costTotal) || 0;
    var gp = direct - cogs - q.financials.freightCost;
    q.financials.gpOfGoods = Math.round(gp * 100) / 100;
    q.financials.gpOfGoodsMargin = direct > 0 ? Math.round((gp / direct) * 1000) / 10 : 0;
  }

  async function saveCost(ref, vendor, btn) {
    var d = dash();
    if (!ref || !vendor) return;
    var input = document.querySelector('.rqd-freight-cost-input[data-ref="' + ref + '"][data-vendor="' + vendor + '"]');
    if (!input) return;
    var raw = (input.value || '').trim().replace(/[$,]/g, '');
    var cost = parseFloat(raw);
    if (isNaN(cost) || cost < 0) { input.focus(); return; }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Loading state without text swap. The
       save button is icon-sized (~28x28); replacing the icon with
       "Saving..." text overflowed the button. Disable + add the shared
       pulse class instead. Success path re-renders the whole detail
       panel (icon goes away with the row). Error path removes the
       loading class — innerHTML is untouched so the SVG icon survives. */
    btn.disabled = true;
    btn.classList.add('rqd-invoice__link--loading');
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    try {
      var resp = await d.API.post('/freight-cost-save', { quoteRef: ref, vendor: vendor, cost: cost });
      if (resp && resp.success) {
        var _entry = (resp.freightQuotes || {})[vendor]
          || { cost: cost, receivedAt: new Date().toISOString() };
        var q = (d.allQuotes || []).find(function (x) { return x.reference === ref; });
        if (q) {
          if (resp.freightQuotes) q.freightQuotes = resp.freightQuotes;
          applyFreightCost(q, vendor, _entry);
          var detailEl = document.getElementById('rqd-detail-' + ref);
          rerenderDetail(detailEl, q);
          if (d.refreshProgressBar) d.refreshProgressBar(ref);
        }
        /* CUSTOM_OPTIMISTIC_BY_CLAUDE (Ryan 2026-08-27) — ⛔ THE REPAINT ABOVE IS NOT ENOUGH, and
           that is the whole bug Ryan reported. It patches the object this closure is holding;
           `fetchQuotes` REPLACES `allQuotes` wholesale on its next tick and the patch goes with it,
           so the row silently reverts to whatever the server said — which, KV being eventually
           consistent, can still be the pre-write value. Registering the write here re-applies it to
           each fresh response until the server's own data carries it. See _pendingPatches. */
        if (d.notePendingPatch) {
          d.notePendingPatch('freight-cost:' + ref + '||' + vendor, ref,
            function (qq) { applyFreightCost(qq, vendor, _entry); },
            function (qq) {
              var srv = ((qq && qq.freightQuotes) || {})[vendor] || {};
              /* Settled when the server reports THIS cost with a receivedAt. Comparing the number
                 rather than mere presence matters: an older saved cost on the same vendor would
                 otherwise clear a newer patch and let the row flip back one last time. */
              return srv.receivedAt != null && Number(srv.cost) === Number(_entry.cost);
            });
        }
      } else {
        alert('Save failed: ' + ((resp && resp.error) || 'unknown'));
        btn.disabled = false;
        btn.classList.remove('rqd-invoice__link--loading');
      }
    } catch (err) {
      alert('Save failed: ' + (err.message || err));
      btn.disabled = false;
      btn.classList.remove('rqd-invoice__link--loading');
    }
  }

  function editCost(ref, vendor) {
    var d = dash();
    var q = (d.allQuotes || []).find(function (x) { return x.reference === ref; });
    if (!q || !q.freightQuotes || !q.freightQuotes[vendor]) return;
    q.freightQuotes[vendor].cost = null;
    q.freightQuotes[vendor].receivedAt = null;
    var detailEl = document.getElementById('rqd-detail-' + ref);
    rerenderDetail(detailEl, q);
  }

  // mode 'cancel' → /freight-cancel-request (rep + admin, only wipes
  //                  pending entries — already-quoted vendors are protected)
  // mode 'reset'  → /freight-quote-reset   (admin force-wipe — can clear an
  //                  already-quoted entry, lossy)
  async function reset(ref, vendor, mode) {
    var d = dash();
    if (!ref || !vendor) return;
    mode = mode === 'reset' ? 'reset' : 'cancel';
    var prompt = mode === 'reset'
      ? 'Reset the freight handshake for ' + vendor + ' on ' + ref + '?\n\nThis clears any existing requestedAt timestamp AND saved freight cost so the row goes back to State 1. Use this when an already-saved cost needs to be wiped (admin only — lossy).'
      : 'Cancel the pending freight request for ' + vendor + ' on ' + ref + '?\n\nThis wipes the requestedAt stamp so the row goes back to "Request Freight". Abby (orders@) is emailed that it is no longer needed and the AI agent stops; the supplier is not contacted. Already-saved costs are protected.';
    if (!confirm(prompt)) return;
    var endpoint = mode === 'reset' ? '/freight-quote-reset' : '/freight-cancel-request';
    try {
      var resp = await d.API.post(endpoint, { quoteRef: ref, vendor: vendor });
      if (resp && resp.success) {
        var q = (d.allQuotes || []).find(function (x) { return x.reference === ref; });
        if (q) {
          q.freightQuotes = resp.freightQuotes || {};
          // /freight-cancel-request also returns the recomputed freightStatus
          // so the truck icon reverts when no pending requests remain.
          if (resp.freightStatus) q.freightStatus = resp.freightStatus;
          if (q.financials) {
            var summed = 0;
            Object.keys(q.freightQuotes).forEach(function (v) {
              var c = parseFloat((q.freightQuotes[v] || {}).cost);
              if (!isNaN(c)) summed += c;
            });
            q.financials.freightCost = Math.round(summed * 100) / 100;
            var direct = parseFloat(q.financials.directTotal) || 0;
            var cogs = parseFloat(q.financials.costTotal) || 0;
            var gp = direct - cogs - q.financials.freightCost;
            q.financials.gpOfGoods = Math.round(gp * 100) / 100;
            q.financials.gpOfGoodsMargin = direct > 0 ? Math.round((gp / direct) * 1000) / 10 : 0;
          }
          var detailEl = document.getElementById('rqd-detail-' + ref);
          rerenderDetail(detailEl, q);
          if (d.refreshProgressBar) d.refreshProgressBar(ref);
        }
      } else {
        alert('Reset failed: ' + ((resp && resp.error) || 'unknown'));
      }
    } catch (err) {
      alert('Reset failed: ' + (err.message || err));
    }
  }

  // ── Shopify fulfillment sync ────────────────────────────────────────
  async function shopifySync(btn) {
    var d = dash();
    var ref = btn.dataset.ref;
    var vendor = btn.dataset.vendor;
    var orderName = btn.dataset.orderName || ref;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-bucket fulfillment. When the row
       carries data-bucket, scope the Shopify fulfillment to just that
       bucket's line items so the customer receives one shipping email
       per bucket. */
    var bucketId = btn.dataset.bucket || '';
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    // The Mark Fulfilled button now lives in a sibling .rqd-vendor-shopify-sync
    // wrapper alongside .rqd-vendor-tracking (both inside .rqd-vendor-item).
    // Walk up to the vendor-item and then back down to the tracking row so
    // we read the rep's typed values. Earlier code used btn.closest(
    // '.rqd-vendor-tracking') which returned null after the button moved
    // out of that wrapper — the silent-click bug.
    var item = btn.closest('.rqd-vendor-item');
    var row = item ? item.querySelector('.rqd-vendor-tracking') : null;
    if (!row) return;
    var trackingInput = row.querySelector('.rqd-vendor-tracking__input');
    var carrierSel = row.querySelector('.rqd-vendor-tracking__carrier');
    var carrierOther = row.querySelector('.rqd-vendor-tracking__carrier-other');
    var urlInput = row.querySelector('.rqd-vendor-tracking__url');
    var status = row.querySelector('.rqd-vendor-tracking__status');
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Capture trackingType
       so Abby's customer email can use the carrier's preferred name for
       the identifier (PRO Number, Shipment ID, BOL #, etc.) instead of
       the generic "tracking number" phrasing. Optional; falls back to
       Abby's default when blank. */
    var typeSel = row.querySelector('.rqd-vendor-tracking__type');
    var typeOther = row.querySelector('.rqd-vendor-tracking__type-other');
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    var trackingNumber = (trackingInput && trackingInput.value || '').trim();
    var carrierRaw = carrierSel ? carrierSel.value : '';
    var carrier = (carrierRaw === 'Other' && carrierOther && carrierOther.value.trim())
      ? carrierOther.value.trim()
      : carrierRaw;
    var trackingUrl = (urlInput && urlInput.value || '').trim();
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — resolve type (handles "Other" → typed label) */
    var typeRaw = typeSel ? typeSel.value : '';
    var trackingType = (typeRaw === 'Other' && typeOther && typeOther.value.trim())
      ? typeOther.value.trim()
      : typeRaw;
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — NO-TRACKING escape hatch. Driving case
       SHOP-1733: shipped in May, tracking never entered, and months later the number is gone.
       The order sat UNFULFILLED in Shopify purely because the portal would not record a
       fulfillment without one, so there was no way to close the row out at all.

       Requires BOTH fields empty, deliberately. Firing on an empty tracking number alone would
       turn "picked a carrier, forgot to type the number" — an ordinary slip — into a silent
       no-tracking fulfillment. Both blank is an unambiguous "I have nothing to enter", and the
       two alerts below still nag on a half-filled form exactly as before.

       The offline card has had this since 2026-05-27 (dashboard-main.js, "customer pickup /
       tracking unavailable"); this is the same hatch for online rows. */
    var noTracking = !trackingNumber && !carrier;
    if (!noTracking) {
      if (!carrier) { alert('Pick a carrier first.'); return; }
      if (!trackingNumber) { alert('Enter a tracking number.'); return; }
    }
    // Carriers whose customer link gets built for the rep — MIRROR of the
    // worker's gate in shopify-fulfillment.js. Two sources, and either is
    // enough: Shopify's own recognized list (normalizeCarrierForShopify), and
    // the carriers WE deep-link ourselves in the worker's
    // src/lib/tracking-urls.js. Anything else genuinely needs a pasted URL or
    // the customer's shipped email has dead tracking.
    // Keep in sync when a carrier is added to tracking-urls.js — this list
    // failing open just means the worker rejects the save with the same
    // message, so a stale entry here is annoying, never wrong.
    var AUTO_LINKED = [
      // Shopify-recognized
      'fedex', 'ups', 'usps', 'dhl', 'ontrac', 'lasership', 'lso', 'tforce',
      'gls', 'newgistics', 'amazon logistics', 'abf', 'estes', 'old dominion',
      'r+l', 'r&l', 'saia', 'yrc', 'yellow freight', 'xpo', 'arcbest',
      'forward air', 'averitt', 'canada post', 'purolator',
      // Ours via tracking-urls.js (Shopify doesn't know these)
      'daylight', 'dylt', 'odfl', 'rl carriers', 'roadrunner', 'rrts',
    ];
    var carrierLower = carrier.toLowerCase();
    var isKnown = AUTO_LINKED.some(function (k) { return carrierLower.indexOf(k) !== -1; });
    // No tracking → no customer email → no link that could be dead, so this gate has nothing
    // to protect. Mirrors the worker's own skip in shopify-fulfillment.js.
    if (!noTracking && !isKnown && !trackingUrl) {
      alert('We have no tracking link for "' + carrier + '" — add the tracking URL and try again, or ask Claude to add the carrier so it links automatically.');
      if (urlInput) urlInput.focus();
      return;
    }

    // Open the Mark Fulfilled confirm modal (matches Shopify's verbiage)
    // with a Notify-customer checkbox checked by default. The modal handles
    // the actual /shopify-fulfillment-create call so the rep gets a
    // pre-flight summary + the option to skip the notification.
    openMarkFulfilledModal({
      ref: ref,
      vendor: vendor,
      bucketId: bucketId,
      orderName: orderName,
      trackingNumber: trackingNumber,
      carrier: carrier,
      trackingUrl: trackingUrl,
      trackingType: trackingType,
      noTracking: noTracking,
      btn: btn,
      status: status,
    });
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — Mark-as-Fulfilled now mirrors the
     PO two-pop-up UX: STEP 1 = the unique-to-this-email controls (shipment info, carrier,
     tracking URL, Notify / business-hours checkboxes, CC), STEP 2 = review + send the email
     (subject + the full editable Abby preview + Send Test). The two steps share one overlay
     and slide between (Continue → / ← Back), matching the PO modal chrome.

     NOTE: unlike the PO / freight-balance prose emails, this step 2 keeps the EXISTING rich
     contenteditable preview (NOT the shared Quill composer RQD.openComposeModal) — the Abby
     shipping email is a server-rendered HTML table (shipped / shipping-now / pending groups)
     that Quill would mangle. So the "one shared composer" rule (see portal CLAUDE.md) does
     not apply to this surface; the two-step *flow + look* is what's mirrored.

     Two-step only runs when Abby owns the email (productionUsesAbby). Legacy vendor-mode rows
     (Shopify's default email, nothing to edit) stay a single step. If "Notify customer" is
     unchecked, step 1's action becomes "Mark Fulfilled" (no email → skip step 2). */
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — recompose a shipping email from the SHARED
     Quill composer's parts: the editor prose + the read-only table block (layered into the
     canvas via the composer's generic previewBlocks — any email type can carry one) + the
     signature. Wrapped in the same outer shell the worker's buildEmailHtml uses, so the sent
     email matches the preview. Quill <p> margins are flattened to 0 (email clients add ~1em). */
  function _normalizeQuillProse(html) {
    return String(html || '').replace(/<p(\s|>)/gi, '<p style="margin:0;"$1');
  }
  // before = prose above the table (Quill editor), table = shipment table, after = tracking +
  // closing (the editable region below the table), sig = signature. The table keeps its correct
  // mid-email position with a clean full blank line on EITHER side of it.
  var _SHIP_BLANK = '<p style="margin:0;font-family:Calibri,Arial,Helvetica,sans-serif;font-size:11pt;line-height:1.4;color:#000;"><br></p>';
  function _composeShippingHtml(beforeHtml, tableHtml, afterHtml, sigHtml) {
    var h = '<div style="font-family:Calibri,Arial,Helvetica,sans-serif;font-size:11pt;line-height:1.4;color:#000;max-width:640px;">';
    h += '<div style="margin:0;">' + _normalizeQuillProse(beforeHtml) + '</div>';
    if (tableHtml) h += _SHIP_BLANK + tableHtml + _SHIP_BLANK;
    h += '<div style="margin:0;">' + _normalizeQuillProse(afterHtml) + '</div>';
    h += _SHIP_BLANK + (sigHtml || '');
    h += '</div>';
    return h;
  }
  /* Preview-canvas blocks for the shipping email. The vertical rhythm is REAL blank-line
     paragraphs (the same _SHIP_BLANK as the sent email), NOT container padding — paired with
     CSS that zeroes the editor/block/signature padding on the shipping canvas, so the preview
     shows exactly one clean blank line before the table, after the table, and before the
     signature (matching what's delivered). The after-table prose stays editable. */
  function _shipPreviewBlocks(tableHtml, afterHtml) {
    if (!tableHtml) return [];
    return [
      _SHIP_BLANK + tableHtml + _SHIP_BLANK,
      '<div class="rqd-ship-afternote" contenteditable="true" spellcheck="true">' + (afterHtml || '') + '</div>' + _SHIP_BLANK,
    ];
  }

  function openMarkFulfilledModal(ctx) {
    var d = dash();
    var existing = document.getElementById('rqd-mark-fulfilled-modal');
    if (existing) existing.remove();

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    var q = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
    var customerName = q && q.customer ? q.customer : '';
    var customerEmail = q && q.customerEmail ? q.customerEmail : '';
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — assigned rep's email, pre-fills the CC
       field below so Abby's shipping email CCs the rep by default (editable). */
    var repEmail = q && q.repEmail ? q.repEmail : '';
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket lineItemIds for the test/prod
       payload. Dashboard derives these live from q.onlineLineItems via
       deriveShippingBucketsForQuote on the worker; they're NOT always
       persisted in wm.shippingBuckets (only custom buckets store them
       explicitly). Without passing them through, the worker can't scope
       the fulfillment or the test email to the right items for
       broker/parcel/combined buckets. The worker prefers the body value
       over the wm value, so this becomes the source of truth for any
       admin-initiated action. */
    var bucketLineItemIds = [];
    if (ctx.bucketId && q && Array.isArray(q.shippingBuckets)) {
      for (var _bli = 0; _bli < q.shippingBuckets.length; _bli++) {
        var _bRec = q.shippingBuckets[_bli];
        if (_bRec && _bRec.id === ctx.bucketId && Array.isArray(_bRec.lineItemIds)) {
          bucketLineItemIds = _bRec.lineItemIds.filter(Boolean);
          break;
        }
      }
    }
    /* CUSTOM_ABBY_BY_CLAUDE — Vendor-mode fallback for the test-email path
       (2026-05-15). When the modal opened from a legacy vendor row (no
       ctx.bucketId, but ctx.vendor present), filter q.onlineLineItems by
       canonical vendor to build the items the test email should render.
       Lets admin preview the Abby render for orders that haven't gone
       through the bucket workflow yet (e.g., SHOP-1697). Production
       trigger stays bucket-only — this is preview only. */
    if (!ctx.bucketId && ctx.vendor && q && Array.isArray(q.onlineLineItems)) {
      var _vendorLower = String(ctx.vendor).trim().toLowerCase();
      bucketLineItemIds = q.onlineLineItems
        .filter(function (li) { return li && li.lineItemId && String(li.vendor || '').trim().toLowerCase() === _vendorLower; })
        .map(function (li) { return li.lineItemId; });
    }
    /* END CUSTOM_ABBY_BY_CLAUDE */
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_ABBY_BY_CLAUDE — Cross-shipment status snapshot for the
       Abby email's grouped table (Ship 2, 2026-05-15). Dashboard sends
       the FULL bucket structure + full lineItem list so the worker can
       render shipped / shipping-now / pending sections without an
       additional graphql round-trip. Worker treats the current bucket
       as "shipping-now" using the request's tracking, regardless of
       this snapshot's shipping state (snapshot is pre-fulfillment). */
    var bucketAssignments = [];
    if (q && Array.isArray(q.shippingBuckets)) {
      for (var _ba = 0; _ba < q.shippingBuckets.length; _ba++) {
        var _b = q.shippingBuckets[_ba];
        if (!_b || !_b.id) continue;
        bucketAssignments.push({
          id: _b.id,
          label: _b.label || _b.id,
          lineItemIds: Array.isArray(_b.lineItemIds) ? _b.lineItemIds.filter(Boolean) : [],
          shipping: _b.shipping || null,
        });
      }
    }
    var orderLineItems = (q && Array.isArray(q.onlineLineItems))
      ? q.onlineLineItems.map(function (li) {
          // Prefer `effectiveQuantity` (override-aware — Order Contents
          // card's source of truth, applies wm.lineQtyOverrides set when
          // admin manually corrects a qty after the fact, e.g.,
          // SHOP-1681's flooring qty bumped 600→646 post-order). Falls
          // back to raw `quantity` when override absent. Per Ryan
          // 2026-05-15.
          var _effQty = parseInt(li.effectiveQuantity, 10);
          if (isNaN(_effQty) || _effQty <= 0) _effQty = parseInt(li.quantity, 10) || 0;
          return {
            lineItemId: li.lineItemId || '',
            title: li.title || '',
            qty: _effQty,
            sku: li.sku || '',
          };
        })
      : [];
    /* END CUSTOM_ABBY_BY_CLAUDE */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Show the bucket label in the modal so
       the rep can see which bucket they're fulfilling (e.g., "Broker
       freight" vs "Supplier parcel"). Lookup against q.shippingBuckets;
       falls back to the bucketId if the bucket isn't found. */
    var bucketLabel = '';
    if (ctx.bucketId && q && Array.isArray(q.shippingBuckets)) {
      for (var _bli = 0; _bli < q.shippingBuckets.length; _bli++) {
        if (q.shippingBuckets[_bli] && q.shippingBuckets[_bli].id === ctx.bucketId) {
          bucketLabel = q.shippingBuckets[_bli].label || ctx.bucketId;
          break;
        }
      }
      if (!bucketLabel) bucketLabel = ctx.bucketId;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom-email + test-button trigger.
       Production trigger fires Abby for bucket-mode rows AND for any
       SHOP-* online row (Ryan 2026-05-19) — Abby now owns customer
       shipping emails on every online order, bucketed or not. The
       Send Test button still renders on every modal so admin can
       preview before fulfilling. */
    var productionUsesAbby = !!ctx.bucketId || /^SHOP-/i.test(String(ctx.ref || ''));
    var showTestButton = true; // always offer the preview, regardless of mode
    var notifyHelper = productionUsesAbby
      ? '(Blue Sky shipping email signed as Abby Rivers — orders@blueskyfitsupply.com)'
      : '(Shopify\'s standard shipped email)';
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — shared fulfill action. POSTs the
       fulfillment, then does the local-state mirror + re-render + row status text. Returns a
       promise; THROWS on failure so the caller (universal-composer sendOverride OR the legacy
       confirm button) drives its own button/close UX. o = { notifyCustomer, ccList,
       businessHoursOnly, subject, html, customerEmail }. */
    function doFulfill(o) {
      var fulfillPayload = {
        ref: ctx.ref,
        orderName: ctx.orderName,
        vendor: ctx.vendor,
        trackingNumber: ctx.trackingNumber,
        trackingCompany: ctx.carrier,
        trackingUrl: ctx.trackingUrl,
        trackingType: ctx.trackingType || '',
        notifyCustomer: o.notifyCustomer,
        ccList: o.ccList || [],
        /* Bcc travels as its own field — the worker has read `body.bcc` all along. See the note
           in the sendOverride above for why it used to arrive folded into ccList. */
        bcc: o.bcc || [],
        businessHoursOnly: o.businessHoursOnly,
        customerName: customerName,
        customerEmail: o.customerEmail || customerEmail,
        bucketAssignments: bucketAssignments,
        orderLineItems: orderLineItems,
        // Rep-edited subject/body from the editable canvas (only when actually
        // changed; otherwise the worker renders the email server-side).
        subject: o.subject,
        html: o.html,
        highImportance: !!o.highImportance,
      };
      if (ctx.bucketId) {
        fulfillPayload.bucketId = ctx.bucketId;
        if (bucketLineItemIds.length > 0) fulfillPayload.bucketLineItemIds = bucketLineItemIds;
      }
      return d.API.post('/shopify-fulfillment-create', fulfillPayload).then(function (resp) {
        if (!(resp && resp.success)) throw new Error((resp && resp.error) || 'Unknown error');
        if (ctx.carrier && ctx.trackingUrl && d.rememberCarrierUrl) {
          try { d.rememberCarrierUrl(ctx.carrier, ctx.trackingUrl, ctx.trackingNumber); } catch (_) {}
        }
        var q2 = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
        if (q2) {
          var todayIso = new Date().toISOString().slice(0, 10);
          // Bucket-mode: mirror EVERY field the bucket-row renderer reads back
          // (incl. trackingType/trackingTypeOther) so the in-place re-render
          // doesn't drop the Type dropdown selection until the next fetch.
          if (ctx.bucketId && Array.isArray(q2.shippingBuckets)) {
            for (var bi = 0; bi < q2.shippingBuckets.length; bi++) {
              if (q2.shippingBuckets[bi] && q2.shippingBuckets[bi].id === ctx.bucketId) {
                q2.shippingBuckets[bi].shipping = {
                  fulfillmentId: resp.fulfillmentId || 'synced',
                  carrier: ctx.carrier || null,
                  trackingNumber: ctx.trackingNumber || null,
                  trackingType: ctx.trackingType || null,
                  trackingTypeOther: ctx.trackingTypeOther || null,
                  trackingUrl: ctx.trackingUrl || null,
                  fulfilledAt: new Date().toISOString(),
                  customerNotified: !!o.notifyCustomer,
                };
                break;
              }
            }
          } else {
            if (!q2.ordering) q2.ordering = {};
            if (!q2.ordering[ctx.vendor]) q2.ordering[ctx.vendor] = {};
            q2.ordering[ctx.vendor].carrier = ctx.carrier || null;
            q2.ordering[ctx.vendor].tracking = ctx.trackingNumber || null;
            q2.ordering[ctx.vendor].trackingType = 'Tracking #';
            q2.ordering[ctx.vendor].trackingUrl = ctx.trackingUrl || null;
            q2.ordering[ctx.vendor].ordered = true;
            q2.ordering[ctx.vendor].date = q2.ordering[ctx.vendor].date || todayIso;
            q2.ordering[ctx.vendor].shipped = true;
            q2.ordering[ctx.vendor].shipDate = todayIso;
            q2.ordering[ctx.vendor].shopifyFulfillmentId = resp.fulfillmentId || 'synced';
            try { d.API.post('/quote-lifecycle', { ref: ctx.ref, ordering: q2.ordering }); } catch (e2) {}
          }
          q2.onlineHasTracking = true;
          var detailEl = document.getElementById('rqd-detail-' + ctx.ref);
          rerenderDetail(detailEl, q2);
          if (d.refreshProgressBar) d.refreshProgressBar(ctx.ref);
        }
        if (ctx.status) {
          if (resp.emailDeferred) {
            ctx.status.textContent = 'Fulfilled · email ' + (resp.emailSendAfterLabel ? 'sends ' + resp.emailSendAfterLabel : 'scheduled');
          } else {
            ctx.status.textContent = o.notifyCustomer ? 'Fulfilled · customer emailed' : 'Fulfilled · no email';
          }
          setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 5000);
        }
        return resp;
      });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — Abby-owned shipping email now runs through
       the ONE universal composer (RQD.openComposeModal) — LITERALLY the same pop-up as the vendor
       PO / freight emails. preStep = the unique shipment + notification controls (same window
       chrome); the compose step is the universal Quill modal. The shipment status table can't be
       Quill prose, so it rides as a generic `previewBlock` layered into the white canvas (the same
       mechanism freight uses for its items table — any email type can carry a table this way).
       editor = greeting/tracking prose (prefillBody), table = previewBlock, signature = Abby's sig
       (signatureHtml). sendOverride recomposes prose + table + signature into the sent email so the
       send matches the preview. We pre-fetch the rendered PARTS (proseHtml/tableHtml/signatureHtml)
       so they're ready. Notify-off in step 1 → fulfill straight away, no email. Legacy vendor-mode
       rows (Shopify's default email, nothing to compose) fall through to the simple confirm below. */
    if (productionUsesAbby && window.RQD && typeof window.RQD.openComposeModal === 'function') {
      var _previewOk = false, _loadedSubject = '', _loadedBefore = '', _loadedTable = '', _loadedAfter = '', _loadedSig = '', _loadedShipToCc = '', _loadedInvoiceAttached = false, _loadedCareGuide = null;
      var _defaultSubject = 'Your order has shipped' + (ctx.orderName ? ' (' + ctx.orderName + ')' : '');
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-30) - this used to RETURN the apology as the
         email body, so a failed preview replaced the draft with prose that reads exactly like the
         message being sent. The note now rides the composer's bottom edge (ctx.noticeHtml) and the
         body is simply left empty. Callers are unchanged - they still assign the return value. */
      var _previewNotice = '';
      function _previewFallback(msg) {
        _previewNotice = 'Preview unavailable (' + msg + '). You can still send — the customer email renders server-side.';
        return '';
      }
      var _preHtml = [
        '<div style="display:grid;grid-template-columns:auto 1fr;column-gap:12px;row-gap:6px;font-size:13px;">',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Order</div><div>' + esc(ctx.orderName) + '</div>',
          bucketLabel ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Shipment</div><div>' + esc(bucketLabel) + '</div>' : '',
          ctx.vendor ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Vendor</div><div>' + esc(ctx.vendor) + '</div>' : '',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Customer</div><div>' + esc(customerName) + (customerEmail ? ' <span style="color:var(--rq-text-secondary);">&lt;' + esc(customerEmail) + '&gt;</span>' : '') + '</div>',
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — no-tracking mode. One honest row
             instead of two empty Carrier / Tracking # cells, which read as a rendering fault. */
          ctx.noTracking
            ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking</div><div style="font-style:italic;">Not recorded — marking fulfilled only</div>'
            : '<div style="color:var(--rq-text-secondary);font-weight:600;">Carrier</div><div>' + esc(ctx.carrier) + '</div>'
              + '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking #</div><div style="font-family:ui-monospace,Menlo,Consolas,monospace;">' + esc(ctx.trackingNumber) + '</div>'
              + (ctx.trackingUrl ? '<div style="color:var(--rq-text-secondary);font-weight:600;">URL</div><div style="word-break:break-all;font-size:12px;">' + esc(ctx.trackingUrl) + '</div>' : ''),
        '</div>',
        /* Notify OFF and locked without tracking — Abby's shipped email is built around a
           clickable tracking link, so there is nothing to compose. Unchecked here also means
           step 1's button reads "Mark Fulfilled" and the compose step is skipped entirely,
           which is exactly the one-click close-out this was added for. The worker forces
           notifyCustomer:false regardless; this makes the reason visible. */
        '<label style="display:flex;align-items:center;gap:8px;margin-top:18px;font-size:13px;font-weight:600;' + (ctx.noTracking ? 'opacity:0.55;cursor:not-allowed;' : 'cursor:pointer;') + '">',
          '<input type="checkbox" id="rqd-mf-notify"' + (ctx.noTracking ? ' disabled' : ' checked') + ' style="width:auto;margin:0;cursor:inherit;">',
          '<span>Notify customer of shipment' + (ctx.noTracking ? ' <span style="font-weight:400;">— unavailable with no tracking</span>' : '') + '</span>',
        '</label>',
        /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-09-06) — the "Send within business hours" box
           MOVED to the compose step. It sat here on step 1, ticked by default, and its value rode
           silently into the send — so on step 2, the screen with the email on it, there was no
           sign the hold was on. Ryan: *"the email composer for these emails doesn't include the
           checkbox to send within business hours."* It is now the composer's own ⏱ toggle
           (showBusinessHours below), ticked by default, and sendOverride reads what the composer
           reports at send time. One control, on the screen where the email is — two boxes that
           could disagree is the trap. The not-notifying branch sends no email, so it never needed
           the box. */
      ].join('');

      // Subject: pass through what's in the box (loaded or rep-edited) when the preview
      // succeeded; otherwise undefined so the worker renders the subject server-side.
      function _outSubject(args) { return _previewOk ? (args.subject || undefined) : undefined; }
      // The editable region below the table (tracking + closing + anything the rep added).
      function _afterHtml() {
        var el = document.querySelector('#rqd-email-modal .rqd-ship-afternote');
        return el ? el.innerHTML : _loadedAfter;
      }
      // Body: recompose before-prose (Quill) + table + after-prose (editable) + signature so
      // the send matches the preview. Preview failed → undefined → worker renders server-side.
      function _outHtml(args) { return _previewOk ? _composeShippingHtml(args.bodyHtml, _loadedTable, _afterHtml(), _loadedSig) : undefined; }

      function _openAbbyComposer(subj) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — split a multi-address customer/ship-to
           field so the first address is the To: and the rest overflow into Cc (see splitRecipients).
           customerEmail (the buyer) leads the To:; the ship-to contact(s) ride in Cc. */
        var _rcpt = splitRecipients(customerEmail, _loadedShipToCc ? [_loadedShipToCc] : []);
        window.RQD.openComposeModal({
          ref: ctx.ref,
          enterFrom: 'right',
          emailType: 'customer-shipping',
          fromOptions: ['ABBY'],   // Abby shipping email → locked From (same pop-up, single sender)
          noticeHtml: _previewNotice || undefined,
          suppressFollowUp: true,
          /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-09-06) — the ⏱ box, on the email itself, ticked.
             Was a checkbox on step 1 whose value rode silently into the send; see the note there. */
          showBusinessHours: true,
          businessHoursDefault: true,
          followUpDefaultNa: true,
          suppressAttachmentGuard: true,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — locked, display-only "Order Invoice"
             pill when the preview says the worker will attach the invoice on the real send. */
          preAttachments: (_loadedInvoiceAttached ? [{ name: 'Order Invoice.pdf', locked: true, displayOnly: true }] : []).concat(_loadedCareGuide && _loadedCareGuide.wouldAttach ? [{ name: _loadedCareGuide.filename || 'ECORE-Floor-Care-Guide.pdf', locked: true, displayOnly: true }] : []),
          prefillTo: _rcpt.to,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-17) — auto-CC rules must show up IN the Cc
             field (visible + removable), never force-added server-side. Pre-fill the ship-to
             contact (dock receiver, from wm.customer.shipEmail, surfaced by the preview as
             shipToContactOnRealSend) so the rep sees it and can remove it before sending. The
             worker no longer force-adds it. No auto-CC of the rep. A 2-address ship-to (or a
             2-address buyer email) is split into separate chips by splitRecipients above. */
          prefillCc: _rcpt.cc,
          prefillSubject: subj,
          prefillBody: _loadedBefore,
          // Table (no header — it has none in the actual email) sits mid-canvas with clean blank
          // lines on either side; below it, the tracking + closing prose is editable (a "text
          // line under the table" any time). Spacing mirrors the sent email exactly.
          previewBlocks: _shipPreviewBlocks(_loadedTable, _loadedAfter),
          signatureHtml: _loadedSig || undefined,
          preStep: {
            title: 'Mark as Fulfilled',
            continueLabel: 'Continue to email →',
            html: _preHtml,
            onMount: function (panel) {
              var notify = panel.querySelector('#rqd-mf-notify');
              var contBtn = panel.querySelector('#rqd-prestep-continue');
              if (notify && contBtn) {
                /* Sync the label to the checkbox's INITIAL state, not just to later changes.
                   continueLabel above is a static 'Continue to email →', which was right while
                   the box was always checked on open — but in no-tracking mode it opens
                   unchecked and disabled, and the button would have promised an email step it
                   then skipped (Ryan 2026-08-12). */
                var _syncLabel = function (checked) {
                  contBtn.textContent = checked ? 'Continue to email →' : 'Mark Fulfilled';
                };
                _syncLabel(notify.checked);
                notify.addEventListener('change', function () { _syncLabel(this.checked); });
              }
            },
            onContinue: function (panel) {
              var notifyEl = panel.querySelector('#rqd-mf-notify');
              var notify = notifyEl ? !!notifyEl.checked : true;
              if (notify) return true;   // → slide to the universal email compose step
              // Not notifying → no email to compose; fulfill straight from step 1, then close.
              var contBtn = panel.querySelector('#rqd-prestep-continue');
              var cancelBtn = panel.querySelector('#rqd-prestep-cancel');
              if (contBtn) { contBtn.disabled = true; contBtn.textContent = 'Fulfilling…'; }
              doFulfill({ notifyCustomer: false, ccList: [], businessHoursOnly: false, subject: undefined, html: undefined, customerEmail: customerEmail })
                .then(function () { if (cancelBtn) cancelBtn.click(); })
                .catch(function (err) {
                  if (contBtn) { contBtn.disabled = false; contBtn.textContent = 'Mark Fulfilled'; }
                  alert('Shopify fulfillment failed: ' + ((err && err.message) || err));
                });
              return false;   // stay on step 1 while the direct fulfill runs
            },
          },
          sendOverride: function (args) {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — ⛔ THIS PUT BCC IN THE CC HEADER.
               The old note said "no separate bcc field on the fulfillment email; a bcc on a
               shipment notice is vanishingly rare" — but /shopify-fulfillment-create has read
               `body.bcc` since it shipped (shopify-fulfillment.js ~L1300), so the field was there
               all along. And "rare" is the wrong test: the composer's Bcc box promises "(optional,
               hidden from other recipients)", so the one time somebody uses it is exactly the time
               they are relying on it. Whoever was quietly copied appeared in the customer's own
               headers. The samples flow below has always kept the two apart. */
            var ccList = (args.cc || []).slice();
            var bccList = (args.bcc || []).slice();
            if (args.isTest) {
              var tp = buildAbbyEmailPayload();
              tp.subject = _outSubject(args);
              tp.html = _outHtml(args);
              return d.API.post('/admin/test-customer-shipping-email', tp).then(function (r) {
                if (!(r && r.success)) throw new Error((r && (r.error || r.details)) || 'Test send failed');
              });
            }
            return doFulfill({
              notifyCustomer: true,
              customerEmail: (args.to && args.to[0]) || customerEmail,
              ccList: ccList,
              bcc: bccList,
              /* The composer's own ⏱ box decides (CUSTOM_SENDWINDOW_BY_CLAUDE, Ryan 2026-09-06). */
              businessHoursOnly: args.businessHoursOnly === true,
              subject: _outSubject(args),
              html: _outHtml(args),
              highImportance: args.highImportance,
            });
          },
        });
      }

      // Pre-fetch the rendered Abby email PARTS (prose / table / signature), then open the
      // composer: prose → Quill editor, table → previewBlock layered in the canvas, signature
      // → signatureHtml. Recomposed on send so what's sent matches what's previewed.
      if (ctx.btn) { ctx.btn.disabled = true; ctx.btn.textContent = 'Loading…'; }
      var _pp = buildAbbyEmailPayload();
      _pp.preview = true;
      d.API.post('/admin/test-customer-shipping-email', _pp)
        .then(function (pr) {
          _previewOk = !!(pr && pr.success && pr.beforeHtml);
          _loadedSubject = _previewOk ? (pr.subject || '') : '';
          _loadedBefore = _previewOk ? pr.beforeHtml : _previewFallback(esc((pr && pr.error) || 'unknown'));
          _loadedTable = _previewOk ? (pr.tableHtml || '') : '';
          _loadedAfter = _previewOk ? (pr.afterHtml || '') : '';
          _loadedSig = _previewOk ? (pr.signatureHtml || '') : '';
          // Ship-to contact (dock receiver) → pre-fill the Cc field (visible + removable),
          // matching the "auto-CC rules live in the Cc field" rule. Worker no longer force-adds it.
          _loadedShipToCc = (pr && pr.shipToContactOnRealSend) ? String(pr.shipToContactOnRealSend) : '';
          _loadedInvoiceAttached = !!(pr && pr.invoiceAttached);
          /* CUSTOM_CAREGUIDE_BY_CLAUDE (Ryan 2026-09-09 PM) — the worker says whether the ECORE care guide
             rides this send; the blurb is already in afterHtml, this is the locked attachment pill. */
          _loadedCareGuide = (pr && pr.careGuide) || null;
          if (ctx.btn) { ctx.btn.disabled = false; ctx.btn.textContent = 'Mark as Fulfilled'; }
          _openAbbyComposer(_loadedSubject || _defaultSubject);
        })
        .catch(function (err) {
          if (ctx.btn) { ctx.btn.disabled = false; ctx.btn.textContent = 'Mark as Fulfilled'; }
          _loadedBefore = _previewFallback(esc((err && err.message) || 'error'));
          _openAbbyComposer(_defaultSubject);
        });
      return;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE — below here is the pre-universal modal: the single-step
       confirm for legacy vendor-mode rows, AND a safety-net two-step Abby modal that only runs
       if the universal composer (RQD.openComposeModal) failed to load. Both call the shared
       doFulfill above. */

    // CUSTOM_RFQPORTAL_BY_CLAUDE — Modal HTML built via array.join() instead
    // of a long `+` chain. Earlier the chain had inline block comments
    // between `+` operators, which JavaScript parsed as `+ (+expr)` —
    // unary-plus on the next operand. When the conditional test row's
    // ternary returned an empty string (non-substituted), the +empty
    // coerced to 0 and the next +closing-tag coerced to NaN, so the
    // rendered HTML contained literal "0NaN" between </label> and </div>.
    // Array.join('') sidesteps the parse ambiguity entirely — each element
    // is its own array slot, no operator-comment interactions.
    // END CUSTOM_RFQPORTAL_BY_CLAUDE
    var testRowHtml = '';
    if (showTestButton) {
      var _testCopy = productionUsesAbby
        ? 'Preview the email — sends the same Abby Rivers shipping notification to your own inbox. No Shopify fulfillment, no tracking pushed to the order.'
        : 'Preview what an Abby Rivers shipping notification would look like for this order. Production for vendor-mode rows still sends Shopify’s default email — this is preview only.';
      testRowHtml = ''
        + '<div id="rqd-mf-test-row" style="margin-top:14px;padding:10px 12px;background:rgba(0,107,204,0.06);border:1px dashed rgba(0,107,204,0.4);border-radius:6px;display:flex;align-items:center;justify-content:space-between;gap:10px;">'
        +   '<div style="font-size:12px;color:var(--rq-text-secondary);line-height:1.4;">' + _testCopy + '</div>'
        +   '<button type="button" class="rqd-pill" id="rqd-mf-sendtest" style="flex:0 0 auto;">Send Test</button>'
        + '</div>';
    }

    /* CUSTOM_ABBY_BY_CLAUDE (2026-06-11) — two-column layout matching the
       offline Notify Customer modal: shipment info + controls on the left,
       the editable email preview on the right. Only when Abby owns the
       production email (productionUsesAbby) — legacy vendor-mode rows send
       Shopify's default email, so there's nothing to edit and the old
       narrow single-column layout stays. */
    var leftColHtml = [
      '<div style="display:grid;grid-template-columns:auto 1fr;column-gap:12px;row-gap:6px;font-size:13px;">',
        '<div style="color:var(--rq-text-secondary);font-weight:600;">Order</div>',
        '<div>' + esc(ctx.orderName) + '</div>',
        bucketLabel ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Shipment</div><div>' + esc(bucketLabel) + '</div>' : '',
        ctx.vendor ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Vendor</div><div>' + esc(ctx.vendor) + '</div>' : '',
        '<div style="color:var(--rq-text-secondary);font-weight:600;">Customer</div>',
        '<div>' + esc(customerName) + (customerEmail ? ' <span style="color:var(--rq-text-secondary);">&lt;' + esc(customerEmail) + '&gt;</span>' : '') + '</div>',
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — no-tracking mode states the absence
           in one row instead of printing two empty Carrier / Tracking # cells, which would
           read as a rendering fault rather than a deliberate choice. */
        ctx.noTracking
          ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking</div><div style="font-style:italic;">Not recorded — marking fulfilled only</div>'
          : '<div style="color:var(--rq-text-secondary);font-weight:600;">Carrier</div>'
            + '<div>' + esc(ctx.carrier) + '</div>'
            + '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking #</div>'
            + '<div style="font-family:ui-monospace,Menlo,Consolas,monospace;">' + esc(ctx.trackingNumber) + '</div>'
            + (ctx.trackingUrl ? '<div style="color:var(--rq-text-secondary);font-weight:600;">URL</div><div style="word-break:break-all;font-size:12px;">' + esc(ctx.trackingUrl) + '</div>' : ''),
      '</div>',
      /* Notify is OFF and locked without tracking: every shipped email is built around a
         clickable tracking link, so there is nothing to send. The worker enforces this too
         (notifyCustomer is forced false there) — this just makes the reason visible. */
      '<label style="display:flex;align-items:center;gap:8px;margin-top:18px;font-size:13px;font-weight:600;' + (ctx.noTracking ? 'opacity:0.55;cursor:not-allowed;' : 'cursor:pointer;') + '">',
        '<input type="checkbox" id="rqd-mf-notify"' + (ctx.noTracking ? ' disabled' : ' checked') + ' style="width:auto;margin:0;cursor:inherit;">',
        '<span>Notify customer of shipment' + (ctx.noTracking ? ' <span style="font-weight:400;">— unavailable with no tracking</span>' : '') + '</span>',
      '</label>',
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — editable CC line, pre-filled with the
         order's rep. Flows to Abby's email as ccList (deduped server-side). */
      '<label style="display:block;margin-top:14px;font-size:13px;font-weight:600;">',
        'CC <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">(comma-separated — emailed when notifying)</span>',
        '<input type="text" id="rqd-mf-cc" value="" placeholder="rep@blueskyfitsupply.com" autocomplete="off" spellcheck="false" style="margin-top:5px;width:100%;box-sizing:border-box;padding:7px 9px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;font-size:13px;background:var(--rq-surface, #fff);color:inherit;">',
      '</label>',
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — business-hours send gate. Default ON:
         outside 6am–6pm MT (7 days), Abby holds the email until 6am the next
         business day (the Shopify fulfillment still fires now). Uncheck to
         email immediately. */
      '<label style="display:flex;align-items:flex-start;gap:8px;margin-top:14px;cursor:pointer;font-size:13px;font-weight:600;">',
        '<input type="checkbox" id="rqd-mf-bizhours" checked style="width:auto;margin:2px 0 0;cursor:pointer;">',
        '<span>Send within business hours <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">(7 days, 6am–6pm MT)</span></span>',
      '</label>',
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* Send Test now lives on step 2 (with the email preview) — see markup below. */
    ].join('');
    /* Right column — editable email preview (Abby playbook §13), same shape
       as the offline Notify Customer modal's. */
    var rightColHtml = productionUsesAbby ? [
      '<div style="flex:1 1 380px;min-width:0;">',
        '<label style="display:block;font-size:13px;font-weight:600;">',
          'Subject',
          '<input type="text" id="rqd-mf-subject" placeholder="Loading preview…" autocomplete="off" spellcheck="false" style="margin-top:5px;width:100%;box-sizing:border-box;padding:7px 9px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;font-size:13px;background:var(--rq-surface, #fff);color:inherit;">',
        '</label>',
        '<div style="margin-top:14px;font-size:13px;font-weight:600;">Email preview <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">— edit the wording as needed; the signature is fixed</span></div>',
        '<div id="rqd-mf-body" contenteditable="false" style="margin-top:5px;max-height:340px;overflow:auto;padding:12px 14px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;background:#fff;color:#000;font-family:Calibri,Arial,Helvetica,sans-serif;font-size:13px;line-height:1.5;">Loading preview…</div>',
      '</div>',
    ].join('') : '';
    var overlay = document.createElement('div');
    overlay.id = 'rqd-mark-fulfilled-modal';
    overlay.className = 'rqd-daterange-backdrop';
    if (productionUsesAbby) {
      /* Two-step (PO-style): step 1 = shipment + notification controls; step 2 = the
         editable email preview + Send Test. Both steps stay in the DOM (display toggled
         + slide-in) so every existing #rqd-mf-* handler, the preview loader, and
         editedSubject()/editedHtml() keep working unchanged. */
      overlay.innerHTML = [
        '<div class="rqd-daterange-modal rqd-mf-modal" role="dialog" aria-label="Mark as Fulfilled" style="width:720px;max-width:96vw;">',
          '<div class="rqd-daterange-modal__header">',
            '<div class="rqd-daterange-modal__title">Mark as Fulfilled</div>',
            '<div class="rqd-daterange-modal__summary" id="rqd-mf-summary">Step 1 of 2 &middot; shipment &amp; notification</div>',
          '</div>',
          // ── Step 1 — shipment + notification controls ──
          '<div class="rqd-mf-step is-active" data-step="1">',
            '<div style="padding:16px 22px;">' + leftColHtml + '</div>',
            '<div class="rqd-daterange-modal__footer">',
              '<button type="button" class="rqd-pill" id="rqd-mf-cancel">Cancel</button>',
              '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-mf-step1-action">Continue to email &rarr;</button>',
            '</div>',
          '</div>',
          // ── Step 2 — email review + send ──
          '<div class="rqd-mf-step" data-step="2">',
            '<div style="padding:16px 22px;">' + rightColHtml + testRowHtml + '</div>',
            '<div class="rqd-daterange-modal__footer">',
              '<button type="button" class="rqd-pill" id="rqd-mf-back">&larr; Back</button>',
              '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-mf-confirm">Mark Fulfilled &amp; Send</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    } else {
      // Legacy vendor-mode row (Shopify's default email — nothing to edit): single step.
      overlay.innerHTML = [
        '<div class="rqd-daterange-modal" role="dialog" aria-label="Mark as Fulfilled" style="max-width:480px;">',
          '<div class="rqd-daterange-modal__header">',
            '<div class="rqd-daterange-modal__title">Mark as Fulfilled</div>',
            '<div class="rqd-daterange-modal__summary">Confirm before sending this fulfillment to Shopify.</div>',
          '</div>',
          '<div style="padding:16px 22px;">' + leftColHtml + testRowHtml + '</div>',
          '<div class="rqd-daterange-modal__footer">',
            '<button type="button" class="rqd-pill" id="rqd-mf-cancel">Cancel</button>',
            '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-mf-confirm">Mark Fulfilled</button>',
          '</div>',
        '</div>'
      ].join('');
    }
    /* END CUSTOM_ABBY_BY_CLAUDE */
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
    portalWrap.appendChild(overlay);

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — step slide. goToStep toggles which
       panel is active and plays a directional slide-in (right=forward, left=back). */
    function goToStep(n, dir) {
      var steps = overlay.querySelectorAll('.rqd-mf-step');
      var summary = overlay.querySelector('#rqd-mf-summary');
      for (var i = 0; i < steps.length; i++) {
        var stepNo = parseInt(steps[i].getAttribute('data-step'), 10);
        var active = stepNo === n;
        steps[i].classList.toggle('is-active', active);
        steps[i].classList.remove('rqd-mf-enter-right', 'rqd-mf-enter-left');
        if (active) {
          void steps[i].offsetWidth; // reflow so the animation restarts each visit
          steps[i].classList.add(dir === 'left' ? 'rqd-mf-enter-left' : 'rqd-mf-enter-right');
        }
      }
      if (summary) summary.innerHTML = n === 2
        ? 'Step 2 of 2 &middot; review &amp; send the email'
        : 'Step 1 of 2 &middot; shipment &amp; notification';
    }
    /* Step-1 action adapts to the Notify checkbox: notifying → "Continue to email →"
       (go to step 2); not notifying → "Mark Fulfilled" (no email, fulfill straight away).
       'change' fires whether they click the box or its label. */
    var _mfNotifyEl = overlay.querySelector('#rqd-mf-notify');
    if (_mfNotifyEl) {
      _mfNotifyEl.addEventListener('change', function () {
        var act = overlay.querySelector('#rqd-mf-step1-action');
        if (act) act.innerHTML = this.checked ? 'Continue to email &rarr;' : 'Mark Fulfilled';
      });
    }

    /* CUSTOM_ABBY_BY_CLAUDE (2026-06-11) — load the editable email preview
       from the worker (subject + rendered body), matching the offline Notify
       Customer modal. Confirm + Send Test stay disabled until it loads; on a
       preview failure both re-enable and the email falls back to the
       server-rendered version (no override sent). Shared payload builder so
       preview / Send Test / confirm all describe the same email. */
    function buildAbbyEmailPayload() {
      return {
        ref: ctx.ref,
        orderName: ctx.orderName,
        bucketId: ctx.bucketId,
        vendor: ctx.vendor,
        bucketLineItemIds: bucketLineItemIds,
        customerName: customerName,
        customerEmail: customerEmail,
        bucketAssignments: bucketAssignments,
        orderLineItems: orderLineItems,
        trackingNumber: ctx.trackingNumber,
        trackingCompany: ctx.carrier,
        trackingUrl: ctx.trackingUrl,
        trackingType: ctx.trackingType || '',
      };
    }
    var previewOk = false, loadedSubject = '', loadedHtml = '';
    var mfSubjEl = overlay.querySelector('#rqd-mf-subject');
    var mfBodyEl = overlay.querySelector('#rqd-mf-body');
    function editedSubject() {
      return (previewOk && mfSubjEl && mfSubjEl.value.trim() !== loadedSubject.trim()) ? mfSubjEl.value.trim() : undefined;
    }
    function editedHtml() {
      return (previewOk && mfBodyEl && mfBodyEl.innerHTML !== loadedHtml) ? mfBodyEl.innerHTML : undefined;
    }
    if (productionUsesAbby) {
      var mfConfirmEl = overlay.querySelector('#rqd-mf-confirm');
      var mfTestEl = overlay.querySelector('#rqd-mf-sendtest');
      if (mfConfirmEl) mfConfirmEl.disabled = true;
      if (mfTestEl) mfTestEl.disabled = true;
      var previewPayload = buildAbbyEmailPayload();
      previewPayload.preview = true;
      d.API.post('/admin/test-customer-shipping-email', previewPayload)
        .then(function (pr) {
          if (pr && pr.success && pr.html) {
            previewOk = true;
            loadedSubject = pr.subject || '';
            loadedHtml = pr.html;
            if (mfSubjEl) mfSubjEl.value = loadedSubject;
            if (mfBodyEl) { mfBodyEl.innerHTML = loadedHtml; mfBodyEl.setAttribute('contenteditable', 'true'); }
          } else if (mfBodyEl) {
            mfBodyEl.textContent = 'Preview unavailable (' + ((pr && pr.error) || 'unknown') + '). You can still Mark Fulfilled — the email renders server-side.';
          }
          if (mfConfirmEl) mfConfirmEl.disabled = false;
          if (mfTestEl) mfTestEl.disabled = false;
        })
        .catch(function (err) {
          if (mfBodyEl) mfBodyEl.textContent = 'Preview unavailable (' + ((err && err.message) || 'error') + '). You can still Mark Fulfilled — the email renders server-side.';
          if (mfConfirmEl) mfConfirmEl.disabled = false;
          if (mfTestEl) mfTestEl.disabled = false;
        });
    }
    /* END CUSTOM_ABBY_BY_CLAUDE */

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onEsc);
    }
    function onEsc(ev) { if (ev.key === 'Escape') close(); }
    document.addEventListener('keydown', onEsc);

    overlay.addEventListener('click', async function (e) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      if (window.RepPortal.dismissedOnBackdrop(e, overlay) || e.target.id === 'rqd-mf-cancel') { close(); return; }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — two-step nav. */
      if (e.target.id === 'rqd-mf-step1-action') {
        var _notifyChk = overlay.querySelector('#rqd-mf-notify');
        if (_notifyChk && !_notifyChk.checked) {
          // Not notifying → no email to review; fulfill straight from step 1.
          var _cb = overlay.querySelector('#rqd-mf-confirm');
          if (_cb) { _cb.disabled = false; _cb.click(); }
        } else {
          goToStep(2, 'right');
        }
        return;
      }
      if (e.target.id === 'rqd-mf-back') { goToStep(1, 'left'); return; }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Send Test handler. Fires the custom
         Blue Sky shipping email to the admin's own inbox using the
         current modal field values. No Shopify side effect. */
      if (e.target.id === 'rqd-mf-sendtest') {
        var testBtn = e.target;
        var origLabel = testBtn.textContent;
        testBtn.textContent = 'Sending…';
        testBtn.disabled = true;
        try {
          /* CUSTOM_ABBY_BY_CLAUDE (2026-06-11) — shared payload builder (same
             fields as before: ref/orderName/bucketId/vendor/bucketLineItemIds/
             customer/bucketAssignments/orderLineItems/tracking*) + the
             rep-edited subject/html from the editable preview so the test
             send mirrors what production will deliver. */
          var testPayload = buildAbbyEmailPayload();
          testPayload.subject = editedSubject();
          testPayload.html = editedHtml();
          var testResp = await d.API.post('/admin/test-customer-shipping-email', testPayload);
          /* END CUSTOM_ABBY_BY_CLAUDE */
          if (testResp && testResp.success) {
            testBtn.textContent = '✓ Sent';
            testBtn.classList.add('rqd-pill--active');
            // Restore after a few seconds so admin can fire more tests in a row.
            setTimeout(function () {
              testBtn.textContent = origLabel;
              testBtn.classList.remove('rqd-pill--active');
              testBtn.disabled = false;
            }, 3500);
          } else {
            var errMsg = (testResp && (testResp.error || testResp.details)) || 'Test send failed';
            testBtn.textContent = origLabel;
            testBtn.disabled = false;
            alert('Test send failed: ' + errMsg);
          }
        } catch (err) {
          testBtn.textContent = origLabel;
          testBtn.disabled = false;
          alert('Test send failed: ' + (err && err.message ? err.message : 'unknown error'));
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      if (e.target.id === 'rqd-mf-confirm') {
        var notifyEl = overlay.querySelector('#rqd-mf-notify');
        var notifyCustomer = notifyEl ? !!notifyEl.checked : true;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — parse the editable CC line into an
           email list (comma / semicolon / whitespace separated) + read the
           business-hours gate. */
        var ccEl = overlay.querySelector('#rqd-mf-cc');
        var ccList = ccEl
          ? ccEl.value.split(/[,;\s]+/).map(function (s) { return s.trim(); }).filter(function (s) { return s.indexOf('@') !== -1; })
          : [];
        var bizEl = overlay.querySelector('#rqd-mf-bizhours');
        var businessHoursOnly = bizEl ? !!bizEl.checked : true;
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var confirmBtn = e.target;
        confirmBtn.textContent = 'Sending…';
        confirmBtn.disabled = true;
        if (ctx.btn) { ctx.btn.disabled = true; ctx.btn.textContent = 'Sending…'; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — legacy single-step path now shares
           doFulfill (same success-side-effects + local-state mirror as the Abby composer path).
           editedSubject()/editedHtml() return undefined here (no editable preview in single-step),
           so the worker renders the email server-side. */
        doFulfill({
          notifyCustomer: notifyCustomer,
          ccList: ccList,
          businessHoursOnly: businessHoursOnly,
          subject: editedSubject(),
          html: editedHtml(),
          customerEmail: customerEmail,
        })
          .then(function () { close(); })
          .catch(function (err) {
            confirmBtn.textContent = 'Mark Fulfilled';
            confirmBtn.disabled = false;
            if (ctx.btn) { ctx.btn.disabled = false; ctx.btn.textContent = 'Mark as Fulfilled'; }
            alert('Shopify fulfillment failed: ' + ((err && err.message) || err));
          });
      }
    });
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — OFFLINE "Notify Customer" pop-up.
     The offline twin of openMarkFulfilledModal. Pure offline deals have no
     Shopify order to fulfill, so there's no fulfillment step — the rep enters
     tracking (auto-saved to /quote-lifecycle) and clicks "Notify Customer" to
     fire Abby's shipping email via POST /notify-customer-shipping. Same
     editable CC line (pre-filled with the order's rep). ctx = {
       ref, vendor, orderName, trackingNumber, carrier, trackingUrl,
       trackingType, items:[{title,qty,sku,handle}], alreadyNotified:bool,
       btn, status }. */
  function openNotifyCustomerModal(ctx) {
    var d = dash();
    var existing = document.getElementById('rqd-notify-customer-modal');
    if (existing) existing.remove();

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    var q = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
    var customerName = q && q.customer ? q.customer : '';
    var customerEmail = q && q.customerEmail ? q.customerEmail : '';
    var repEmail = q && q.repEmail ? q.repEmail : '';
    var items = Array.isArray(ctx.items) ? ctx.items : [];

    if (!customerEmail) {
      alert('No customer email on file for this order — add one on the customer card, or forward tracking manually.');
      return;
    }

    var isResend = !!ctx.alreadyNotified;
    var confirmLabel = isResend ? 'Resend to Customer' : 'Send to Customer';

    /* What the pre-step's choice means to the worker. `auto` adds NOTHING to the payload, which
       is byte-for-byte the request every send made before this control existed.

       ⛔ CUSTOM_NCTHREADSCOPE_BY_CLAUDE (2026-09-20) — HOISTED OUT OF THE COMPOSER `if` BLOCK,
       where it used to live, to sit beside its only caller in the same function scope.
       It was NOT broken: this file never actually enters strict mode (the `use strict` on line 35
       is not the first statement of the IIFE, so it is an inert string literal), and in sloppy
       mode Annex B.3.3 hoists a block function's NAME to the enclosing FUNCTION scope and assigns
       it when the block runs. `doNotify` is only ever called from inside that same block, so the
       assignment had always happened first.
       ⚠️ IT WAS ONE EDIT FROM BREAKING, IN TWO DIFFERENT WAYS: give this file a real `use strict`
       (or make it a module) and a block-scoped declaration stops being visible to `doNotify` at
       all — lexically, not just in time; or call `doNotify` from the legacy bespoke modal, which
       lives outside that block, and the name is still `undefined` when it runs.
       ⚠️ `_ncThreads` is a `var` inside that block, so it is function-scoped already and is still
       resolvable from here. tests/block-scoped-function-tests.mjs is the guard that flagged this. */
    function _ncThreadChoice() {
      var sel = document.getElementById('rqd-nc-thread');
      var v = sel ? String(sel.value || 'auto') : 'auto';
      if (v === 'fresh') return { forceFresh: true };
      if (v.indexOf('reply:') === 0) {
        var m = _ncThreads[parseInt(v.slice(6), 10)];
        if (m && m.messageId) {
          return {
            replyToMessageId: m.messageId,
            replyToInternetMessageId: m.internetMessageId || '',
            replyToConversationId: m.conversationId || '',
          };
        }
      }
      return {};
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — shared send + mark-only actions, used by
       the universal-composer flow below. Mirror the doFulfill pattern: POST + local-state mirror
       + row status; the composer drives button/close UX. doNotify throws on failure. */
    function doNotify(o) {
      /* CUSTOM_SHIPFROM_BY_CLAUDE / CUSTOM_SHIPTHREAD_BY_CLAUDE (AIOPS 89721f96ff00) — the
         composer's From selector and the pre-step's thread choice, MERGED onto the payload rather
         than passed beside it. The worker ignores a REP pick from a non-admin, so `fromMailbox` is
         a request and not a decision. */
      return d.API.post('/notify-customer-shipping', Object.assign({
        ref: ctx.ref, vendor: ctx.vendor, items: items,
        fromMailbox: o.fromMailbox === 'REP' ? 'REP' : 'ABBY',
        ccList: o.ccList || [], resend: isResend,
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-30) - the shipment as the composer showed
           it. The worker prefers these over its KV copy, so a send can't race the row's debounced
           auto-save (or mail the number the rep just replaced). See the ctx note in
           dashboard-main.js. */
        trackingNumber: ctx.trackingNumber || '', carrier: ctx.carrier || '',
        trackingUrl: ctx.trackingUrl || '', trackingType: ctx.trackingType || '',
        /* Bcc as Bcc, and the composer's typed recipient — neither of which this payload used to
           carry. See the note on the sendOverride that calls this. An empty customerEmail means
           "use the address on the deal", which is the behaviour every existing caller relies on. */
        bcc: o.bcc || [],
        customerEmail: o.customerEmail || '',
        businessHoursOnly: o.businessHoursOnly,
        subject: o.subject, html: o.html,
        highImportance: !!o.highImportance,
        orderName: ctx.shopifyOrderName || '',
      }, _ncThreadChoice())).then(function (resp) {
        if (resp && resp.success && resp.deferred) {
          var q3 = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
          if (q3) {
            if (!q3.customerShippingEmails) q3.customerShippingEmails = {};
            q3.customerShippingEmails[ctx.vendor] = { scheduledFor: resp.sendAfter, to: customerEmail, cc: o.ccList || [] };
            rerenderDetail(document.getElementById('rqd-detail-' + ctx.ref), q3);
          }
          if (ctx.status) { ctx.status.textContent = resp.sendAfterLabel ? ('Scheduled · ' + resp.sendAfterLabel) : 'Scheduled'; setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 5000); }
          return resp;
        }
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — ⛔ A SKIPPED SEND WAS RECORDED AS A
           SENT ONE. Only the single reason 'no customer email' was caught; every OTHER skip the
           worker can report — a suppressed address, a hard-bounced one — fell through to the
           branch below, which stamps `customerNotifiedAt`, writes a `customerShippingEmails`
           entry with a timestamp, locks the row to notified and prints "Customer emailed".
           Nobody follows up on a customer the system believes it has already told.

           `skipped` means the worker did NOT send. There is no reason for which stamping a
           notification is correct, so the reason is now surfaced rather than enumerated — a new
           skip reason added worker-side can no longer arrive here as a silent success. */
        if (resp && resp.success && resp.skipped) {
          throw new Error(resp.reason === 'no customer email'
            ? 'No customer email on file for this order — forward tracking manually.'
            : 'The customer was NOT emailed' + (resp.reason ? ' (' + resp.reason + ')' : '') + '. Nothing has been recorded as sent.');
        }
        warnIfSubjectDroppedRef(resp);
        if (resp && resp.success && resp.sent) {
          var nowIso = new Date().toISOString();
          var q2 = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
          if (q2) {
            if (!q2.ordering) q2.ordering = {};
            if (!q2.ordering[ctx.vendor]) q2.ordering[ctx.vendor] = {};
            q2.ordering[ctx.vendor].customerNotifiedAt = nowIso;
            if (!q2.customerShippingEmails) q2.customerShippingEmails = {};
            q2.customerShippingEmails[ctx.vendor] = { at: nowIso, to: customerEmail, cc: o.ccList || [] };
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — the shipping email carried the invoice
               (worker stamped + returned it) → reflect Invoiced on the AR/AP card immediately, no
               manual refresh. */
            if (resp.invoiced) {
              q2.invoiced = true;
              if (resp.invoice) { q2.invoice = resp.invoice; q2.invoicedDate = resp.invoice.generatedDate || q2.invoicedDate; }
            }
            rerenderDetail(document.getElementById('rqd-detail-' + ctx.ref), q2);
          }
          if (ctx.status) { ctx.status.textContent = 'Customer emailed'; setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 3500); }
          return resp;
        }
        throw new Error((resp && resp.error) || 'Unknown error');
      });
    }
    function doMarkOnly() {
      return d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, markOnly: true, orderName: ctx.shopifyOrderName || '' }).then(function (resp) {
        if (!(resp && resp.success && resp.marked)) throw new Error((resp && resp.error) || 'Unknown error');
        var moNow = new Date().toISOString();
        var qM = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
        if (qM) {
          if (!qM.ordering) qM.ordering = {};
          if (!qM.ordering[ctx.vendor]) qM.ordering[ctx.vendor] = {};
          qM.ordering[ctx.vendor].customerNotifiedAt = moNow;
          if (!qM.customerShippingEmails) qM.customerShippingEmails = {};
          qM.customerShippingEmails[ctx.vendor] = { at: moNow, to: '', cc: [], markedOnly: true };
          rerenderDetail(document.getElementById('rqd-detail-' + ctx.ref), qM);
        }
        if (ctx.status) { ctx.status.textContent = 'Marked notified · no email'; setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 4000); }
        return resp;
      });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — Notify Customer now runs through the ONE
       universal composer (LITERALLY the same pop-up as Mark-as-Fulfilled / vendor PO / freight):
       preStep = shipment summary + business-hours + "mark notified without emailing"; the compose
       step is the universal Quill modal. prose → editor (prefillBody), shipment status table →
       previewBlock layered into the canvas, Abby signature → signatureHtml. sendOverride recomposes
       prose + table + signature so the send matches the preview → /notify-customer-shipping. Abby
       email → locked From. The legacy bespoke modal below only runs if the composer JS failed. */
    if (window.RQD && typeof window.RQD.openComposeModal === 'function') {
      var _previewOk = false, _loadedSubject = '', _loadedBefore = '', _loadedTable = '', _loadedAfter = '', _loadedSig = '', _loadedInvoiceAttached = false, _loadedCareGuide = null;
      var _ncOrderLabel = ctx.orderName || ctx.ref || '';
      var _defaultSubject = 'Your order has shipped' + (_ncOrderLabel ? ' (' + _ncOrderLabel + ')' : '');
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-30) - this used to RETURN the apology as the
         email body, so a failed preview replaced the draft with prose that reads exactly like the
         message being sent. The note now rides the composer's bottom edge (ctx.noticeHtml) and the
         body is simply left empty. Callers are unchanged - they still assign the return value. */
      var _previewNotice = '';
      function _previewFallback(msg) {
        _previewNotice = 'Preview unavailable (' + msg + '). You can still send — the customer email renders server-side.';
        return '';
      }
      var _preHtml = [
        '<div style="display:grid;grid-template-columns:auto 1fr;column-gap:12px;row-gap:6px;font-size:13px;">',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Order</div><div>' + esc(_ncOrderLabel) + '</div>',
          ctx.vendor ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Shipment</div><div>' + esc(ctx.vendor) + '</div>' : '',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Customer</div><div>' + esc(customerName) + (customerEmail ? ' <span style="color:var(--rq-text-secondary);">&lt;' + esc(customerEmail) + '&gt;</span>' : '') + '</div>',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Carrier</div><div>' + esc(ctx.carrier || '') + '</div>',
          '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking #</div><div style="font-family:ui-monospace,Menlo,Consolas,monospace;">' + esc(ctx.trackingNumber || '') + '</div>',
          ctx.trackingUrl ? '<div style="color:var(--rq-text-secondary);font-weight:600;">URL</div><div style="word-break:break-all;font-size:12px;">' + esc(ctx.trackingUrl) + '</div>' : '',
        '</div>',
        /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-09-06) — the "Send within business hours" box
           MOVED to the compose step (the composer's ⏱ toggle, ticked by default); see the note on
           the Mark-as-Fulfilled pre-step above. "Mark notified without emailing" sends nothing, so
           it never needed the box. */
        /* CUSTOM_SHIPTHREAD_BY_CLAUDE (AIOPS 89721f96ff00, Ryan 2026-09-14) — new email, or a
           reply on something the customer already wrote. RW-1367-B's customer emailed Ryan asking
           for a status and Abby answered on a fresh chain, which reads as though nobody had read
           her note. The rows are filled in from /deal-email-thread once it answers; until then the
           control shows only its default, so a slow or failed lookup costs the CHOICE and never
           the email. */
        '<label style="display:block;margin-top:14px;font-size:13px;font-weight:600;color:var(--rq-text-secondary);">Send as',
          '<select id="rqd-nc-thread" class="rqd-email-modal__compose-input" style="display:block;width:100%;margin-top:4px;font-size:13px;cursor:pointer;">',
            '<option value="auto" selected>Let Abby decide (replies on the customer\u2019s own thread when there is one)</option>',
            '<option value="fresh">Start a new email</option>',
          '</select>',
        '</label>',
        '<label style="display:flex;align-items:flex-start;gap:8px;margin-top:14px;cursor:pointer;font-size:13px;font-weight:600;">',
          '<input type="checkbox" id="rqd-nc-markonly-cb" style="width:auto;margin:2px 0 0;cursor:pointer;">',
          '<span>Mark notified without emailing <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">(for orders the customer already received — no email sent)</span></span>',
        '</label>',
      ].join('');

      /* The thread rows, fetched once the pre-step is on screen. Never blocks the pop-up: the
         rule dashboard-main.js's own reply chooser already follows, because a lookup that fails
         must fall through to the behaviour this pop-up has always had. */
      var _ncThreads = [];
      function _ncFillThreads(panel) {
        if (!ctx.ref || !d.API || !d.API.get) return;
        d.API.get('/deal-email-thread?ref=' + encodeURIComponent(ctx.ref))
          .then(function (t) {
            var emails = (t && Array.isArray(t.emails)) ? t.emails : [];
            /* ⛔ ONLY MESSAGES THE CUSTOMER SENT. Replying onto one of OUR sends quotes our own
               email back at them, and the case where they have already answered one of ours is
               what the worker's anchor rule covers by itself. */
            _ncThreads = emails.filter(function (m) { return m && m.direction === 'inbound' && m.messageId; }).slice(0, 5);
            if (!_ncThreads.length) return;
            var live = (panel || document).querySelector('#rqd-nc-thread') || document.getElementById('rqd-nc-thread');
            if (!live) return;
            _ncThreads.forEach(function (m, i) {
              var who = m.fromName || m.from || 'the customer';
              var when = m.receivedAt ? String(m.receivedAt).slice(0, 10) : '';
              var o = document.createElement('option');
              o.value = 'reply:' + i;
              o.textContent = 'Reply to ' + who + (when ? ' (' + when + ')' : '') + ' \u2014 ' + String(m.subject || '(no subject)').slice(0, 60);
              live.appendChild(o);
            });
          })
          .catch(function () { /* the default still sends */ });
      }

      // Subject pass-through (preview ok → send box value; else worker renders server-side).
      function _outSubject(args) { return _previewOk ? (args.subject || undefined) : undefined; }
      // The editable region below the table (tracking + closing + anything the rep added).
      function _afterHtml() {
        var el = document.querySelector('#rqd-email-modal .rqd-ship-afternote');
        return el ? el.innerHTML : _loadedAfter;
      }
      // Recompose before-prose (Quill) + table + after-prose (editable) + signature so the send
      // matches the preview; preview failed → undefined → worker renders server-side.
      function _outHtml(args) { return _previewOk ? _composeShippingHtml(args.bodyHtml, _loadedTable, _afterHtml(), _loadedSig) : undefined; }

      function _openComposer(subj) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — the two customer addresses live in the
           SHIP-TO field (q.shipTo.email = wm.customer.shipEmail, kept whole, e.g. RW-1177-B
           "elewis@…, cadams@…"); the dashboard trims q.customerEmail to the FIRST address only,
           so sourcing from it dropped the 2nd CC. Source from the ship-to string so BOTH show:
           first→To, the rest→Cc, with the order's rep staying Cc'd (removable). Fall back to
           customerEmail when the deal has no ship-to. See splitRecipients. */
        var _shipToFull = (q && q.shipTo && q.shipTo.email) ? q.shipTo.email : '';
        var _rcpt = splitRecipients(_shipToFull || customerEmail, repEmail ? [repEmail] : []);
        window.RQD.openComposeModal({
          ref: ctx.ref,
          enterFrom: 'right',
          emailType: 'customer-shipping',
          /* CUSTOM_SHIPFROM_BY_CLAUDE (AIOPS 89721f96ff00, Ryan 2026-09-14) — was `['ABBY']`, which
             the composer renders as a DISABLED select. An admin may now answer from ryan@ when the
             customer wrote to Ryan in the first place; the composer swaps the signature with the
             selection and the worker swaps the Resend identity to match, so the name, the address
             and the reply-to can never disagree. ⛔ Admins only: a rep picking REP would be writing
             to a customer out of the owner's mailbox. ⚠️ `session.admin`, NOT `session.role` — role
             reads "rep" for admins (custom-rep-portal.js says so twice). */
          fromOptions: _ncIsAdmin() ? ['ABBY', 'REP'] : ['ABBY'],
          noticeHtml: _previewNotice || undefined,
          suppressFollowUp: true,
          /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-09-06) — the ⏱ box, on the email itself, ticked.
             Was a checkbox on step 1 whose value rode silently into the send; see the note there. */
          showBusinessHours: true,
          businessHoursDefault: true,
          suppressAttachmentGuard: true,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — locked, display-only "Order Invoice"
             pill when the preview says the worker will attach the invoice on the real send. */
          preAttachments: (_loadedInvoiceAttached ? [{ name: 'Order Invoice.pdf', locked: true, displayOnly: true }] : []).concat(_loadedCareGuide && _loadedCareGuide.wouldAttach ? [{ name: _loadedCareGuide.filename || 'ECORE-Floor-Care-Guide.pdf', locked: true, displayOnly: true }] : []),
          prefillTo: _rcpt.to,
          prefillCc: _rcpt.cc,
          prefillSubject: subj,
          prefillBody: _loadedBefore,
          // Table (no header) mid-canvas with clean blank lines on either side; tracking +
          // closing prose editable below it. Spacing mirrors the sent email exactly.
          previewBlocks: _shipPreviewBlocks(_loadedTable, _loadedAfter),
          signatureHtml: _loadedSig || undefined,
          preStep: {
            title: isResend ? 'Resend Shipping Notice' : 'Notify Customer of Shipment',
            continueLabel: 'Continue to email →',
            html: _preHtml,
            onMount: function (panel) {
              var mo = panel.querySelector('#rqd-nc-markonly-cb');
              var contBtn = panel.querySelector('#rqd-prestep-continue');
              if (mo && contBtn) mo.addEventListener('change', function () { contBtn.textContent = this.checked ? 'Mark Notified · No Email' : 'Continue to email →'; });
              _ncFillThreads(panel);   // CUSTOM_SHIPTHREAD_BY_CLAUDE — fills the reply rows in the background
            },
            onContinue: function (panel) {
              var moEl = panel.querySelector('#rqd-nc-markonly-cb');
              if (moEl && moEl.checked) {
                // Mark notified without emailing → no compose step.
                var contBtn = panel.querySelector('#rqd-prestep-continue');
                var cancelBtn = panel.querySelector('#rqd-prestep-cancel');
                if (contBtn) { contBtn.disabled = true; contBtn.textContent = 'Marking…'; }
                doMarkOnly()
                  .then(function () { if (cancelBtn) cancelBtn.click(); })
                  .catch(function (err) {
                    if (contBtn) { contBtn.disabled = false; contBtn.textContent = 'Mark Notified · No Email'; }
                    alert('Could not mark as notified: ' + ((err && err.message) || err));
                  });
                return false;
              }
              return true;
            },
          },
          sendOverride: function (args) {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — two bugs on one line.
               ⛔ Bcc was folded into Cc, so the composer's "(optional, hidden from other
                  recipients)" promise was false — see the note on the fulfillment sendOverride.
               ⛔ And `args.to` was never forwarded at all, so the To box was decorative: the
                  operator could retype the recipient, see it change, send, and read "✓ Sent."
                  while the worker mailed the address on the record. Both now travel. */
            var ccList = (args.cc || []).slice();
            var bccList = (args.bcc || []).slice();
            if (args.isTest) {
              return d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, items: items, test: true, subject: _outSubject(args), html: _outHtml(args), trackingNumber: ctx.trackingNumber || '', carrier: ctx.carrier || '', trackingUrl: ctx.trackingUrl || '', trackingType: ctx.trackingType || '' }).then(function (r) {
                if (!(r && r.success)) throw new Error((r && (r.error || r.details)) || 'Test send failed');
              });
            }
            return doNotify({
              ccList: ccList, bcc: bccList,
              customerEmail: (args.to && args.to[0]) || '',
              /* The composer's own ⏱ box decides (CUSTOM_SENDWINDOW_BY_CLAUDE, Ryan 2026-09-06). */
              businessHoursOnly: args.businessHoursOnly === true, subject: _outSubject(args), html: _outHtml(args), highImportance: args.highImportance,
            });
          },
        });
      }

      var _ncBtnLabel = ctx.btn ? ctx.btn.textContent : '';
      if (ctx.btn) { ctx.btn.disabled = true; ctx.btn.textContent = 'Loading…'; }
      d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, items: items, resend: isResend, preview: true, trackingNumber: ctx.trackingNumber || '', carrier: ctx.carrier || '', trackingUrl: ctx.trackingUrl || '', trackingType: ctx.trackingType || '' })
        .then(function (pr) {
          _previewOk = !!(pr && pr.success && pr.beforeHtml);
          _loadedSubject = _previewOk ? (pr.subject || '') : '';
          _loadedBefore = _previewOk ? pr.beforeHtml : _previewFallback(esc((pr && pr.error) || 'unknown'));
          _loadedTable = _previewOk ? (pr.tableHtml || '') : '';
          _loadedAfter = _previewOk ? (pr.afterHtml || '') : '';
          _loadedSig = _previewOk ? (pr.signatureHtml || '') : '';
          _loadedInvoiceAttached = !!(pr && pr.invoiceAttached);
          /* CUSTOM_CAREGUIDE_BY_CLAUDE (Ryan 2026-09-09 PM) — the worker says whether the ECORE care guide
             rides this send; the blurb is already in afterHtml, this is the locked attachment pill. */
          _loadedCareGuide = (pr && pr.careGuide) || null;
          if (ctx.btn) { ctx.btn.disabled = false; ctx.btn.textContent = _ncBtnLabel; }
          _openComposer(_loadedSubject || _defaultSubject);
        })
        .catch(function (err) {
          if (ctx.btn) { ctx.btn.disabled = false; ctx.btn.textContent = _ncBtnLabel; }
          _loadedBefore = _previewFallback(esc((err && err.message) || 'error'));
          _openComposer(_defaultSubject);
        });
      return;
    }

    var overlay = document.createElement('div');
    overlay.id = 'rqd-notify-customer-modal';
    overlay.className = 'rqd-daterange-backdrop';
    overlay.innerHTML = [
      '<div class="rqd-daterange-modal" role="dialog" aria-label="Notify Customer of Shipment" style="max-width:940px;">',
        '<div class="rqd-daterange-modal__header">',
          '<div class="rqd-daterange-modal__title">Notify Customer of Shipment</div>',
          '<div class="rqd-daterange-modal__summary">Sends the Blue Sky shipping email (signed Abby Rivers — orders@blueskyfitsupply.com).' + (isResend ? ' This shipment was already emailed — resending.' : '') + '</div>',
        '</div>',
        '<div style="padding:16px 22px;">',
          /* CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — two-column layout: shipment info
             + controls on the left, the editable email preview on the right, so
             the modal stays short enough that the footer Send button is visible.
             flex-wrap stacks the columns on a narrow (mobile) viewport. */
          '<div class="rqd-nc-cols" style="display:flex;flex-wrap:wrap;gap:22px;align-items:flex-start;">',
            '<div style="flex:1 1 300px;min-width:0;">',
              '<div style="display:grid;grid-template-columns:auto 1fr;column-gap:12px;row-gap:6px;font-size:13px;">',
                '<div style="color:var(--rq-text-secondary);font-weight:600;">Order</div>',
                '<div>' + esc(ctx.orderName || ctx.ref) + '</div>',
                ctx.vendor ? '<div style="color:var(--rq-text-secondary);font-weight:600;">Shipment</div><div>' + esc(ctx.vendor) + '</div>' : '',
                '<div style="color:var(--rq-text-secondary);font-weight:600;">Customer</div>',
                '<div>' + esc(customerName) + ' <span style="color:var(--rq-text-secondary);">&lt;' + esc(customerEmail) + '&gt;</span></div>',
                '<div style="color:var(--rq-text-secondary);font-weight:600;">Carrier</div>',
                '<div>' + esc(ctx.carrier || '') + '</div>',
                '<div style="color:var(--rq-text-secondary);font-weight:600;">Tracking #</div>',
                '<div style="font-family:ui-monospace,Menlo,Consolas,monospace;">' + esc(ctx.trackingNumber || '') + '</div>',
                ctx.trackingUrl ? '<div style="color:var(--rq-text-secondary);font-weight:600;">URL</div><div style="word-break:break-all;font-size:12px;">' + esc(ctx.trackingUrl) + '</div>' : '',
              '</div>',
              '<label style="display:block;margin-top:16px;font-size:13px;font-weight:600;">',
                'CC <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">(comma-separated)</span>',
                ((window.RQD && window.RQD.abbyEmailDatalist) ? window.RQD.abbyEmailDatalist() : '') +
                '<input type="text" list="rqd-abby-emails" id="rqd-nc-cc" value="' + esc(repEmail) + '" placeholder="rep@blueskyfitsupply.com" autocomplete="off" spellcheck="false" style="margin-top:5px;width:100%;box-sizing:border-box;padding:7px 9px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;font-size:13px;background:var(--rq-surface, #fff);color:inherit;">',
              '</label>',
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — business-hours send gate (default ON). */
              '<label style="display:flex;align-items:flex-start;gap:8px;margin-top:14px;cursor:pointer;font-size:13px;font-weight:600;">',
                '<input type="checkbox" id="rqd-nc-bizhours" checked style="width:auto;margin:2px 0 0;cursor:pointer;">',
                '<span>Send within business hours <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">(7 days, 6am–6pm MT)</span></span>',
              '</label>',
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Send Test row (mirrors the online modal): previews the exact Abby email to the admin's own inbox, no side effects. */
              '<div style="margin-top:16px;padding:10px 12px;background:rgba(0,107,204,0.06);border:1px dashed rgba(0,107,204,0.4);border-radius:6px;display:flex;align-items:center;justify-content:space-between;gap:10px;">',
                '<div style="font-size:12px;color:var(--rq-text-secondary);line-height:1.4;">Preview the email — sends this exact Abby Rivers notification to your own inbox. No customer send, no Deal Feed entry.</div>',
                '<button type="button" class="rqd-pill" id="rqd-nc-sendtest" style="flex:0 0 auto;">Send Test</button>',
              '</div>',
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            '</div>',
            /* RIGHT column — editable email preview (Abby playbook §13). */
            '<div style="flex:1 1 380px;min-width:0;">',
              '<label style="display:block;font-size:13px;font-weight:600;">',
                'Subject',
                '<input type="text" id="rqd-nc-subject" placeholder="Loading preview…" autocomplete="off" spellcheck="false" style="margin-top:5px;width:100%;box-sizing:border-box;padding:7px 9px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;font-size:13px;background:var(--rq-surface, #fff);color:inherit;">',
              '</label>',
              '<div style="margin-top:14px;font-size:13px;font-weight:600;">Email preview <span style="color:var(--rq-text-secondary);font-weight:400;font-size:11px;">— edit the wording as needed; the signature is fixed</span></div>',
              '<div id="rqd-nc-body" contenteditable="false" style="margin-top:5px;max-height:340px;overflow:auto;padding:12px 14px;border:1px solid var(--rq-border, rgba(0,0,0,0.18));border-radius:6px;background:#fff;color:#000;font-family:Calibri,Arial,Helvetica,sans-serif;font-size:13px;line-height:1.5;">Loading preview…</div>',
            '</div>',
          '</div>',
        '</div>',
        '<div class="rqd-daterange-modal__footer">',
          '<button type="button" class="rqd-pill" id="rqd-nc-cancel" style="margin-right:auto;">Cancel</button>',
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Mark notified without emailing (for
             backfilled orders the customer already received). Ghost/secondary
             so "Send to Customer" stays the primary action. */
          '<button type="button" class="rqd-pill" id="rqd-nc-markonly" title="Mark this shipment as notified without emailing the customer — for orders they already received">Mark Notified · No Email</button>',
          '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-nc-confirm">' + confirmLabel + '</button>',
        '</div>',
      '</div>'
    ].join('');
    var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
    portalWrap.appendChild(overlay);

    /* CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — load the editable email preview from
       the worker (subject + rendered body), per Abby playbook §13. Send buttons
       stay disabled until it loads so nothing goes out without a preview; on a
       preview failure we re-enable and fall back to the server-rendered email
       (no override sent). Mark-Notified is never gated. */
    var previewOk = false, loadedSubject = '', loadedHtml = '';
    var subjEl = overlay.querySelector('#rqd-nc-subject');
    var bodyEl = overlay.querySelector('#rqd-nc-body');
    var confirmBtnEl = overlay.querySelector('#rqd-nc-confirm');
    var testBtnEl = overlay.querySelector('#rqd-nc-sendtest');
    if (confirmBtnEl) confirmBtnEl.disabled = true;
    if (testBtnEl) testBtnEl.disabled = true;
    d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, items: items, resend: isResend, preview: true })
      .then(function (pr) {
        if (pr && pr.success && pr.html) {
          previewOk = true;
          loadedSubject = pr.subject || '';
          loadedHtml = pr.html;
          if (subjEl) subjEl.value = loadedSubject;
          if (bodyEl) { bodyEl.innerHTML = loadedHtml; bodyEl.setAttribute('contenteditable', 'true'); }
        } else if (bodyEl) {
          bodyEl.textContent = 'Preview unavailable (' + ((pr && pr.error) || 'unknown') + '). You can still send — the email renders server-side — or use Mark Notified.';
        }
        if (confirmBtnEl) confirmBtnEl.disabled = false;
        if (testBtnEl) testBtnEl.disabled = false;
      })
      .catch(function (err) {
        if (bodyEl) bodyEl.textContent = 'Preview unavailable (' + ((err && err.message) || 'error') + '). You can still send — the email renders server-side — or use Mark Notified.';
        if (confirmBtnEl) confirmBtnEl.disabled = false;
        if (testBtnEl) testBtnEl.disabled = false;
      });

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onEsc);
    }
    function onEsc(ev) { if (ev.key === 'Escape') close(); }
    document.addEventListener('keydown', onEsc);

    overlay.addEventListener('click', async function (e) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      if (window.RepPortal.dismissedOnBackdrop(e, overlay) || e.target.id === 'rqd-nc-cancel') { close(); return; }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Send Test: preview to admin's own inbox, no side effects. */
      if (e.target.id === 'rqd-nc-sendtest') {
        var testBtn = e.target;
        var origLabel = testBtn.textContent;
        testBtn.textContent = 'Sending…';
        testBtn.disabled = true;
        try {
          var tResp = await d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, items: items, test: true, subject: (previewOk && subjEl && subjEl.value.trim() !== loadedSubject.trim()) ? subjEl.value.trim() : undefined, html: (previewOk && bodyEl && bodyEl.innerHTML !== loadedHtml) ? bodyEl.innerHTML : undefined });
          if (tResp && tResp.success) {
            testBtn.textContent = '✓ Sent';
            testBtn.classList.add('rqd-pill--active');
            setTimeout(function () { testBtn.textContent = origLabel; testBtn.classList.remove('rqd-pill--active'); testBtn.disabled = false; }, 3500);
          } else {
            testBtn.textContent = origLabel; testBtn.disabled = false;
            alert('Test send failed: ' + ((tResp && tResp.error) || 'unknown error'));
          }
        } catch (err) {
          testBtn.textContent = origLabel; testBtn.disabled = false;
          alert('Test send failed: ' + (err && err.message ? err.message : 'unknown error'));
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Mark Notified (No Email): set the notified
         marker without sending an email (backfilled orders the customer already
         received). Flips the row to "Fulfilled ✓" + locked, same as a real send. */
      if (e.target.id === 'rqd-nc-markonly') {
        var moBtn = e.target;
        moBtn.textContent = 'Marking…';
        moBtn.disabled = true;
        if (ctx.btn) { ctx.btn.disabled = true; }
        try {
          var moResp = await d.API.post('/notify-customer-shipping', { ref: ctx.ref, vendor: ctx.vendor, markOnly: true, orderName: ctx.shopifyOrderName || '' });
          if (moResp && moResp.success && moResp.marked) {
            var moNow = new Date().toISOString();
            var qM = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
            if (qM) {
              if (!qM.ordering) qM.ordering = {};
              if (!qM.ordering[ctx.vendor]) qM.ordering[ctx.vendor] = {};
              qM.ordering[ctx.vendor].customerNotifiedAt = moNow;
              if (!qM.customerShippingEmails) qM.customerShippingEmails = {};
              qM.customerShippingEmails[ctx.vendor] = { at: moNow, to: '', cc: [], markedOnly: true };
              rerenderDetail(document.getElementById('rqd-detail-' + ctx.ref), qM);
            }
            if (ctx.status) {
              ctx.status.textContent = 'Marked notified · no email';
              setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 4000);
            }
            close();
          } else {
            moBtn.textContent = 'Mark Notified · No Email'; moBtn.disabled = false;
            if (ctx.btn) { ctx.btn.disabled = false; }
            alert('Could not mark as notified: ' + ((moResp && moResp.error) || 'unknown error'));
          }
        } catch (err) {
          moBtn.textContent = 'Mark Notified · No Email'; moBtn.disabled = false;
          if (ctx.btn) { ctx.btn.disabled = false; }
          alert('Could not mark as notified: ' + (err && err.message ? err.message : 'unknown error'));
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      if (e.target.id !== 'rqd-nc-confirm') return;

      var ccEl = overlay.querySelector('#rqd-nc-cc');
      var ccList = ccEl
        ? ccEl.value.split(/[,;\s]+/).map(function (s) { return s.trim(); }).filter(function (s) { return s.indexOf('@') !== -1; })
        : [];
      var bizEl = overlay.querySelector('#rqd-nc-bizhours');
      var businessHoursOnly = bizEl ? !!bizEl.checked : true;
      var confirmBtn = e.target;
      confirmBtn.textContent = 'Sending…';
      confirmBtn.disabled = true;
      if (ctx.btn) { ctx.btn.disabled = true; }
      try {
        var resp = await d.API.post('/notify-customer-shipping', {
          ref: ctx.ref,
          vendor: ctx.vendor,
          items: items,
          ccList: ccList,
          resend: isResend,
          businessHoursOnly: businessHoursOnly,
          /* CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — rep-edited subject/body from the
             editable preview (only when it loaded; otherwise the server renders). */
          subject: (previewOk && subjEl && subjEl.value.trim() !== loadedSubject.trim()) ? subjEl.value.trim() : undefined,
          html: (previewOk && bodyEl && bodyEl.innerHTML !== loadedHtml) ? bodyEl.innerHTML : undefined,
          // Linked Shopify order (offline-paid-online): worker silently marks
          // it fulfilled (no Shopify email) alongside Abby's send.
          orderName: ctx.shopifyOrderName || '',
        });
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — deferred to business hours: mark the
           row "Scheduled" (cron sends it at the next 6am MT window). */
        if (resp && resp.success && resp.deferred) {
          var q3 = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
          if (q3) {
            if (!q3.customerShippingEmails) q3.customerShippingEmails = {};
            q3.customerShippingEmails[ctx.vendor] = { scheduledFor: resp.sendAfter, to: customerEmail, cc: ccList };
            rerenderDetail(document.getElementById('rqd-detail-' + ctx.ref), q3);
          }
          if (ctx.status) {
            ctx.status.textContent = resp.sendAfterLabel ? ('Scheduled · ' + resp.sendAfterLabel) : 'Scheduled';
            setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 5000);
          }
          close();
          return;
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — same defect as the composer path
           above: only 'no customer email' was caught, so any other skip reason was recorded as a
           successful notification. See the fuller note there. */
        if (resp && resp.success && resp.skipped) {
          confirmBtn.textContent = confirmLabel;
          confirmBtn.disabled = false;
          if (ctx.btn) { ctx.btn.disabled = false; }
          alert(resp.reason === 'no customer email'
            ? 'No customer email on file for this order — forward tracking manually.'
            : 'The customer was NOT emailed' + (resp.reason ? ' (' + resp.reason + ')' : '') + '. Nothing has been recorded as sent.');
          return;
        }
        warnIfSubjectDroppedRef(resp);
        if (resp && resp.success && resp.sent) {
          var nowIso = new Date().toISOString();
          var q2 = (d.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
          if (q2) {
            if (!q2.ordering) q2.ordering = {};
            if (!q2.ordering[ctx.vendor]) q2.ordering[ctx.vendor] = {};
            q2.ordering[ctx.vendor].customerNotifiedAt = nowIso;
            if (!q2.customerShippingEmails) q2.customerShippingEmails = {};
            q2.customerShippingEmails[ctx.vendor] = { at: nowIso, to: customerEmail, cc: ccList };
            var detailEl = document.getElementById('rqd-detail-' + ctx.ref);
            rerenderDetail(detailEl, q2);
          }
          if (ctx.status) {
            ctx.status.textContent = 'Customer emailed';
            setTimeout(function () { if (ctx.status) ctx.status.textContent = ''; }, 3500);
          }
          close();
        } else {
          confirmBtn.textContent = confirmLabel;
          confirmBtn.disabled = false;
          if (ctx.btn) { ctx.btn.disabled = false; }
          alert('Could not send the customer email: ' + ((resp && resp.error) || 'Unknown error'));
        }
      } catch (err) {
        confirmBtn.textContent = confirmLabel;
        confirmBtn.disabled = false;
        if (ctx.btn) { ctx.btn.disabled = false; }
        alert('Could not send the customer email: ' + (err && err.message ? err.message : err));
      }
    });
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — "Notify Customer — samples
     shipped" modal. Lets the rep optionally paste the samples department's
     "here's what we're mailing" note → POST /extract-sample-items (Claude) →
     populate an editable Item/Qty table → Send Test (preview to admin) or Send
     to Customer. Tracking + items are both OPTIONAL: the no-list variant of
     Abby's email reads cleanly without either, the with-list variant uses the
     reviewed table. The rep email pre-fills CC; the rep is always named by
     first name inside the email body (handled server-side). ctx = {
       ref, customerEmail, customerName, repFirstName, repEmail,
       tracking: { number, carrier, url }, btn (the triggering button) }. */
  function openSampleNotifyModal(ctx) {
    if (!ctx || !ctx.ref) return;
    var d = dash();
    var prior = document.getElementById('rqd-sample-notify-overlay');
    if (prior) prior.remove();

    function esc(s) {
      var el = document.createElement('div');
      el.textContent = String(s == null ? '' : s);
      return el.innerHTML;
    }

    var refSafe = String(ctx.ref || '');
    /* CUSTOM_SAMPLECONTACT_BY_CLAUDE (Ryan 2026-09-23) — when the Samples card's one-time Shipping Address carries an email, Abby's
       notice goes to THAT person (the one holding the box) and the Sold To rides in Cc. Same rule the
       automatic notice and the follow-up ladder apply on the worker (lib/sample-contact.js). The composer's
       To / Cc stay editable, so a rep can still override either. */
    var soldToCc = [];
    (function () {
      var sst = ctx.sampleShipTo || null;
      var shipEmail = String((sst && sst.email) || '').trim();
      if (shipEmail.indexOf('@') === -1) return;
      var soldEmail = String(ctx.customerEmail || '').split(/[,;]/)[0].trim();
      if (soldEmail && soldEmail.toLowerCase() !== shipEmail.toLowerCase()) soldToCc = [soldEmail];
      ctx = Object.assign({}, ctx, { customerEmail: shipEmail, customerName: String((sst && sst.name) || ctx.customerName || '') });
    })();
    var custName = String(ctx.customerName || '').trim();
    var custNameDisplay = custName || '(no name on file)';
    var custEmail = String(ctx.customerEmail || '').trim();
    var custEmailDisplay = custEmail || '(no email on file)';
    var repFirstName = String(ctx.repFirstName || '').trim();
    var repEmail = String(ctx.repEmail || '').trim();
    var trk = ctx.tracking || {};
    var trkNum = String(trk.number || '').trim();
    var trkCarrier = String(trk.carrier || '').trim() || (trkNum ? 'FedEx Ground' : '');
    var trkUrl = String(trk.url || '').trim();
    var trackingSummary = trkNum
      ? (esc(trkCarrier) + ' · ' + esc(trkNum))
      : 'No tracking # (the email reads "packed up and on the way")';
    /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: the card hands over the second
       set's tracking (`ctx.pair`) once it exists; the worker's preview adds one sentence naming it and
       the send stamps it on the marker. The second recipient is never addressed — the buyer gets both. */
    var pair = (ctx.pair && ctx.pair.tracking && ctx.pair.tracking.number) ? ctx.pair : null;
    if (pair) {
      trackingSummary += ' · 2nd set to ' + esc(pair.name || 'the second recipient') + ': ' + esc(pair.tracking.number);
    }

    var overlay = document.createElement('div');
    overlay.id = 'rqd-sample-notify-overlay';
    overlay.className = 'rqd-daterange-backdrop';
    overlay.innerHTML = [
      '<div class="rqd-daterange-modal" style="max-width:680px;padding:24px 28px;">',
      '  <h3 class="rqd-daterange-modal__title" style="margin-top:0;">Notify customer — samples shipped</h3>',
      '  <div style="font-size:12px;color:var(--rq-text-secondary);margin-bottom:14px;">',
      '    ' + esc(refSafe) + ' · ' + esc(custNameDisplay) + ' &lt;' + esc(custEmailDisplay) + '&gt; · ' + trackingSummary,
      '  </div>',
      '  <label style="display:block;font-size:11px;font-weight:600;color:var(--rq-text-secondary);margin-bottom:4px;letter-spacing:0.04em;text-transform:uppercase;">Samples department\'s "here\'s what we\'re mailing" note (optional)</label>',
      '  <textarea id="rqd-sn-raw" rows="4" placeholder="Paste the samples department\'s confirmation here and Abby will extract the items into a table — or skip this entirely and send without a list." style="width:100%;padding:8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);resize:vertical;box-sizing:border-box;"></textarea>',
      '  <div style="display:flex;align-items:center;gap:10px;margin:6px 0 14px;">',
      '    <button type="button" id="rqd-sn-extract" class="rqd-pill" style="font-size:11px;">Extract items</button>',
      '    <span id="rqd-sn-extract-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <label style="display:block;font-size:11px;font-weight:600;color:var(--rq-text-secondary);margin-bottom:4px;letter-spacing:0.04em;text-transform:uppercase;">Items going on the email (edit anything Abby got wrong)</label>',
      '  <div id="rqd-sn-items" style="border:1px solid var(--rq-border);border-radius:6px;padding:8px;margin-bottom:6px;max-height:220px;overflow-y:auto;"></div>',
      '  <button type="button" id="rqd-sn-add-row" class="rqd-pill" style="font-size:11px;margin-bottom:14px;">+ Add row</button>',
      '  <div style="font-size:11px;color:var(--rq-text-secondary);margin-bottom:6px;">Next: preview &amp; edit the email (subject, message, To / Cc / Bcc), send yourself a test, then send to the customer. The rep is pre-filled on Cc.</div>',
      '  <div class="rqd-daterange-modal__footer">',
      '    <button type="button" id="rqd-sn-cancel" class="rqd-pill" style="margin-right:auto;">Cancel</button>',
      '    <button type="button" id="rqd-sn-markonly" class="rqd-pill" title="Save the tracking and mark the customer notified — no email sent (for when the rep emails the customer directly)">Mark as Notified</button>',
      '    <button type="button" id="rqd-sn-continue" class="rqd-pill rqd-pill--active">Continue to email →</button>',
      '  </div>',
      '</div>',
    ].join('\n');

    var mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
    mountWrap.appendChild(overlay);

    function rowHtml(title, qty) {
      return '<div class="rqd-sn-row" style="display:flex;gap:6px;align-items:center;margin-bottom:4px;">'
        + '<input type="text" class="rqd-sn-row__title" placeholder="Product — Color" value="' + esc(title || '') + '" style="flex:1;padding:6px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);">'
        + '<input type="number" class="rqd-sn-row__qty" min="1" max="999" value="' + (Number.isFinite(parseInt(qty, 10)) && parseInt(qty, 10) > 0 ? parseInt(qty, 10) : 1) + '" style="width:60px;padding:6px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);text-align:right;">'
        + '<button type="button" class="rqd-sn-row__remove" title="Remove row" style="background:transparent;border:0;color:var(--rq-text-secondary);font-size:16px;line-height:1;cursor:pointer;padding:0 6px;">×</button>'
        + '</div>';
    }
    function populateRows(items) {
      var box = overlay.querySelector('#rqd-sn-items');
      if (!Array.isArray(items) || items.length === 0) {
        box.innerHTML = '<div style="font-size:11px;color:var(--rq-text-secondary);padding:6px 4px;">No items yet.</div>';
        return;
      }
      box.innerHTML = items.map(function (it) { return rowHtml(it.title || '', it.qty); }).join('');
    }
    function readItems() {
      var rows = overlay.querySelectorAll('.rqd-sn-row');
      var out = [];
      rows.forEach(function (row) {
        var t = String((row.querySelector('.rqd-sn-row__title') || {}).value || '').trim();
        var q = parseInt((row.querySelector('.rqd-sn-row__qty') || {}).value, 10);
        if (!t) return;
        if (!Number.isFinite(q) || q < 1) q = 1;
        if (q > 999) q = 999;
        out.push({ title: t, qty: q });
      });
      return out;
    }
    function trackingObj() {
      if (!(trkNum || trkCarrier || trkUrl)) return null;
      var t = {};
      if (trkNum) t.number = trkNum;
      if (trkCarrier) t.carrier = trkCarrier;
      if (trkUrl) t.url = trkUrl;
      return t;
    }
    function getRepSessionEmail() {
      try { var raw = sessionStorage.getItem('rep_portal_session'); return raw ? ((JSON.parse(raw) || {}).email || '').trim() : ''; } catch (_) { return ''; }
    }

    populateRows([]);

    function close() { overlay.remove(); }
    overlay.querySelector('#rqd-sn-cancel').addEventListener('click', close);
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
    overlay.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, overlay)) close(); });

    overlay.querySelector('#rqd-sn-add-row').addEventListener('click', function () {
      var box = overlay.querySelector('#rqd-sn-items');
      if (box.querySelectorAll('.rqd-sn-row').length === 0) box.innerHTML = '';
      box.insertAdjacentHTML('beforeend', rowHtml('', 1));
      var rows = box.querySelectorAll('.rqd-sn-row');
      var last = rows[rows.length - 1];
      var inp = last && last.querySelector('.rqd-sn-row__title');
      if (inp) inp.focus();
    });

    overlay.querySelector('#rqd-sn-items').addEventListener('click', function (e) {
      var rmBtn = e.target && e.target.closest && e.target.closest('.rqd-sn-row__remove');
      if (!rmBtn) return;
      var row = rmBtn.closest('.rqd-sn-row');
      if (row) row.remove();
      if (overlay.querySelectorAll('.rqd-sn-row').length === 0) populateRows([]);
    });

    var extractBtn = overlay.querySelector('#rqd-sn-extract');
    var extractStatus = overlay.querySelector('#rqd-sn-extract-status');
    extractBtn.addEventListener('click', async function () {
      var raw = String((overlay.querySelector('#rqd-sn-raw') || {}).value || '').trim();
      if (!raw) { extractStatus.textContent = 'Paste something above first.'; return; }
      extractBtn.disabled = true;
      extractBtn.textContent = 'Extracting…';
      extractStatus.textContent = '';
      try {
        var resp = await d.API.post('/extract-sample-items', { raw: raw });
        if (resp && Array.isArray(resp.items)) {
          populateRows(resp.items);
          extractStatus.textContent = resp.items.length > 0
            ? '✓ Pulled ' + resp.items.length + ' item' + (resp.items.length === 1 ? '' : 's') + ' — review/edit before sending.'
            : 'No items found — try + Add row to enter manually, or send without a list.';
        } else {
          extractStatus.textContent = 'Couldn\'t parse the response.';
        }
      } catch (err) {
        extractStatus.textContent = 'Error: ' + (err && err.message ? err.message : 'extraction failed');
      } finally {
        extractBtn.disabled = false;
        extractBtn.textContent = 'Extract items';
      }
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-18) — Step 1 → shared composer.
       This first overlay just gathers the reviewed item list; "Continue" fetches
       the server-rendered email PARTS (preview mode) and hands off to the ONE
       universal compose modal (RQD.openComposeModal). The composer owns the
       editable subject / message / To / Cc / Bcc, Send Test, and the real send;
       the actual email goes out AS Abby (orders@) over Outlook via abbySendCore,
       same transport + pattern as the delay-notice email. */
    var continueBtn = overlay.querySelector('#rqd-sn-continue');
    continueBtn.addEventListener('click', function () {
      if (!custEmail) { alert('No customer email on file — fill that in on the lead/quote first.'); return; }
      var items = readItems();
      continueBtn.disabled = true;
      continueBtn.textContent = 'Loading…';
      d.API.post('/notify-customer-samples', {
        preview: true,
        ref: refSafe,
        customerEmail: custEmail,
        customerName: custName,
        repFirstName: repFirstName,
        items: items,
        tracking: trackingObj(),
        pair: pair, // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient
      }).then(function (parts) {
        if (!parts || parts.success === false) throw new Error((parts && parts.error) || 'Could not build the email');
        close();
        openSampleComposer(items, parts);
      }).catch(function (err) {
        continueBtn.disabled = false;
        continueBtn.textContent = 'Continue to email →';
        alert('Could not build the email: ' + (err && err.message ? err.message : 'unknown error'));
      });
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-25) — "Mark as Notified" (no email).
       Saves nothing new (the Notify Customer click already persisted the tracking
       via /quote-sample-tracking-save); this just marks the deal customer-notified
       WITHOUT sending Abby's email, for when the rep emails the customer themselves.
       markOnly mode stamps sampleNotifiedAt + the lead auto-hold / pending 7-day
       follow-up server-side. Mirrors the send path's in-place refresh so the card
       flips to the notified ✓ state without a full reload. */
    var markOnlyBtn = overlay.querySelector('#rqd-sn-markonly');
    if (markOnlyBtn) markOnlyBtn.addEventListener('click', function () {
      var items = readItems();
      var _orig = markOnlyBtn.textContent;
      markOnlyBtn.disabled = true;
      markOnlyBtn.textContent = 'Saving…';
      d.API.post('/notify-customer-samples', {
        ref: refSafe,
        markOnly: true,
        customerEmail: custEmail,
        customerName: custName,
        repFirstName: repFirstName,
        items: items,
        tracking: trackingObj(),
        pair: pair, // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient
      }).then(function (res) {
        if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Could not mark as notified');
        if (ctx.btn) { ctx.btn.disabled = true; ctx.btn.textContent = 'Notified ✓'; }
        close();
        try {
          var _dd = dash();
          var _q = (_dd.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
          if (_q && typeof _dd.buildDetailHtml === 'function') {
            _q.sampleNotifiedAt = new Date().toISOString();
            var _holdable = (['new_lead', 'sample', 'on_hold', 'dead_lead'].indexOf(_q.status) !== -1
              || _q.isLead || _q.isSample || _q.isOnHold || _q.isDeadLead) && !_q.lifecycleStatus;
            if (_holdable) {
              _q.status = 'on_hold'; _q.isOnHold = true; _q.isSample = false;
              _q.holdUntil = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
              _q.holdReason = _q.holdReason || 'Samples sent — auto-hold';
            }
            var _de = document.getElementById('rqd-detail-' + ctx.ref);
            if (_de) _de.innerHTML = _dd.buildDetailHtml(_q);
          }
        } catch (_) { /* in-place refresh is best-effort; next fetch reconciles */ }
      }).catch(function (err) {
        markOnlyBtn.disabled = false;
        markOnlyBtn.textContent = _orig;
        alert('Could not mark as notified: ' + (err && err.message ? err.message : 'unknown error'));
      });
    });

    /* Hand the server-rendered email to the shared compose modal. KISS: the
       WHOLE email is one editable Quill body (greeting → items → tracking →
       closing); no locked blocks. Abby's real signature shows via signatureHtml
       (appended server-side on send) for reassurance it's included. */
    function openSampleComposer(items, parts) {
      if (!(window.RQD && typeof window.RQD.openComposeModal === 'function')) {
        alert('Email composer unavailable — reload the page and try again.');
        return;
      }
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — split a multi-address custEmail so the
      // first address is To: and the rest overflow into Cc (see splitRecipients). The deal's
      // current assignee (server-resolved) rides in Cc as before; removable chip.
      var _rcpt = splitRecipients(custEmail, soldToCc.concat((parts.repEmail || repEmail) ? [parts.repEmail || repEmail] : [])); // CUSTOM_SAMPLECONTACT_BY_CLAUDE (Ryan 2026-09-23)
      window.RQD.openComposeModal({
        ref: refSafe,
        fromOptions: ['ABBY'],   // Abby-only email → locked From box (single sender)
        suppressFollowUp: true,
        prefillTo: _rcpt.to,
        // Cc the deal's current assignee (server-resolved, so it's correct even
        // when the ref prefix differs from the assignee); removable chip.
        prefillCc: _rcpt.cc,
        prefillSubject: parts.subject || '',
        // richBody (contentEditable), NOT prefillBody (Quill): Quill drops the
        // inline <p> margins that carry the blank-line spacing; the contentEditable
        // preserves them in the preview AND the sent email. The signature rides
        // inside richBody (canvas has no separate sig region), so it's shown too.
        richBody: parts.html || '',
        sendOverride: function (args) {
          var base = {
            ref: refSafe,
            // customerEmail satisfies the worker's required-field gate on BOTH
            // paths; a test still routes to testRecipient, a real send overrides
            // this with the (editable) To below.
            customerEmail: custEmail,
            subject: args.subject,
            html: args.bodyHtml,
            richBody: true,
            items: items,
            tracking: trackingObj(),
            pair: pair, // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient
            customerName: custName,
            repFirstName: repFirstName,
            cc: (args.cc || []).join(','),
            bcc: (args.bcc || []).join(','),
          };
          function fire(extra) { return d.API.post('/notify-customer-samples', Object.assign({}, base, extra)); }
          function onSent(res) {
            // Treat any error payload as a failure even when the worker resolves
            // (vs throws) — e.g. the 409 "already sent" body — so we never stamp
            // Notified ✓ on a non-send.
            if (!res || res.success === false || res.error) throw new Error((res && res.error) || 'Send failed');
            if (ctx.btn) { ctx.btn.disabled = true; ctx.btn.textContent = 'Notified ✓'; }
            /* Reflect the worker's auto-hold (+7d) + sample-notified flag in
               place: re-render ONLY this deal's detail panel so the ON HOLD
               banner + the Shipment Tracking checkmark appear immediately —
               no full reload (keeps scroll + the row open). */
            try {
              var _dd = dash();
              var _q = (_dd.allQuotes || []).find(function (x) { return x.reference === ctx.ref; });
              if (_q && typeof _dd.buildDetailHtml === 'function') {
                _q.sampleNotifiedAt = new Date().toISOString();
                var _holdable = (['new_lead', 'sample', 'on_hold', 'dead_lead'].indexOf(_q.status) !== -1
                  || _q.isLead || _q.isSample || _q.isOnHold || _q.isDeadLead) && !_q.lifecycleStatus;
                if (_holdable) {
                  _q.status = 'on_hold'; _q.isOnHold = true; _q.isSample = false;
                  _q.holdUntil = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
                  _q.holdReason = _q.holdReason || 'Samples sent — auto-hold';
                }
                var _de = document.getElementById('rqd-detail-' + ctx.ref);
                if (_de) _de.innerHTML = _dd.buildDetailHtml(_q);
              }
            } catch (_) { /* in-place refresh is best-effort; next fetch reconciles */ }
            return res;
          }
          if (args.isTest) {
            return fire({ test: true, testRecipient: getRepSessionEmail() || repEmail || (args.to || [])[0] || '' });
          }
          return fire({ customerEmail: (args.to || [])[0] || custEmail })
            .then(onSent)
            .catch(function (err) {
              var msg = err && err.message ? err.message : '';
              if (/already sent/i.test(msg) && confirm(msg + '\n\nSend it again?')) {
                return fire({ customerEmail: (args.to || [])[0] || custEmail, resend: true }).then(onSent);
              }
              throw err;
            });
        },
      });
    }
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — send the PO without waiting for this
     supplier's freight quote, or undo that. Same shape as reset() above: confirm, post, re-render
     the one panel. The confirm is worth keeping on the skip — it lifts a deliberate gate — but not
     on the undo, which only restores the safer state. */
  async function skip(ref, vendor, clear) {
    var d = dash();
    if (!ref || !vendor) return;
    var _skipMsg = 'Skip the freight request for ' + vendor + ' on ' + ref + '?\n\n'
      + 'Generate PO unlocks without their quote. Nothing is entered as a cost, so the deal keeps '
      + 'whatever freight figure it already had — check it before you invoice.';
    if (!clear && !confirm(_skipMsg)) return;
    try {
      var resp = await d.API.post('/freight-skip', { quoteRef: ref, vendor: vendor, clear: !!clear });
      if (resp && resp.success) {
        var q = (d.allQuotes || []).find(function (x) { return x.reference === ref; });
        if (q) {
          q.freightQuotes = resp.freightQuotes || q.freightQuotes || {};
          rerenderDetail(document.getElementById('rqd-detail-' + ref), q);
          if (d.refreshProgressBar) d.refreshProgressBar(ref);
        }
      } else {
        alert((resp && resp.error) || 'Could not update the freight skip.');
      }
    } catch (err) {
      alert((err && err.message) ? err.message : 'Could not update the freight skip.');
    }
  }
  /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */

  /* CUSTOM_PRODUCTRULES_BY_CLAUDE (Session 7) - the dashboard may have read the saved West list before this loaded. */
  if (window.RepRuleSettings && Array.isArray(window.RepRuleSettings.ecoreWestStates)) setEcoreWestStates(window.RepRuleSettings.ecoreWestStates);

  window.DashboardHandshake = {
    request: request,
    skip: skip,   // CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26)
    requestDims: requestDims,
    requestBoth: requestBoth,
    saveCost: saveCost,
    editCost: editCost,
    reset: reset,
    shopifySync: shopifySync,
    openNotifyCustomerModal: openNotifyCustomerModal,
    openSampleNotifyModal: openSampleNotifyModal,
    getVendorFreightExtras: getVendorFreightExtras,
    setEcoreWestStates: setEcoreWestStates, // CUSTOM_PRODUCTRULES_BY_CLAUDE Session 7 - the saved list (GET /rule-settings)
    /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — exported for the Fulfillment card's
       freight-cost save, which is the fifth mutation handler this was factored out for
       ("adding a new mutation handler now is one line", above). Re-rendering one detail panel
       in place is what lets a save land instantly instead of waiting on a board re-fetch. */
    rerenderDetail: rerenderDetail,
  };
})();
